export const locale = {
  general_menu_settings: 'إعدادات القائمة العامة',
  settings: {
  business_type_title: 'اختر نوع نشاط القائمة',
  currency_label: 'العملة',
  show_filter: 'عرض فلتر المنتجات',
  show_categories: 'عرض فئات المنتجات',
  
  business_types: {
    cafe: 'مقهى',
    restaurant: 'مطعم',
    fastfood: 'وجبات سريعة',
    icecream: 'عصير ومثلجات',
    sweets: 'حلويات',
    bakery: 'مخبز'
  },
  
  custom_labels: {
        ph_menu_cafe: 'قائمة المقهى',
    ph_menu_restaurant: 'قائمة الطعام',
    ph_menu_fastfood: 'قائمة الوجبات السريعة',
    ph_menu_icecream: 'العصير والآيس كريم',
    ph_menu_sweets: 'الكعك والحلويات',
    ph_menu_bakery: 'الخبز والمخبوزات',
    ph_product_list: 'المنتجات',
    ph_add_order: 'إضافة',
    ph_add_cart: 'شراء',

    title: 'تخصيص التسميات (اختياري)',
    subtitle: 'استبدل مصطلحات النظام الافتراضية بكلماتك المفضلة.',
    products_title: 'عنوان قسم المنتجات',
    ph_food_menu: 'قائمة الطعام',
    ph_product_list: 'قائمة المنتجات',
    cart_btn: 'نص زر الشراء',
    ph_add_order: 'أضف إلى الطلب',
    ph_add_cart: 'أضف إلى السلة'
  },

  currencies: {
    toman: 'تومان',
    rial: 'ريال'
  }
},
check_account_balance_and_try_again: 'يرجى التحقق من رصيد الحساب والمحاولة مرة أخرى',
problem_with_qr_renewal_request: 'حدثت مشكلة أثناء طلب تجديد رمز QR',

  ERRORS: {
    PhoneIsNotValid: "رقم الهاتف المدخل غير صحيح: مثال 09101234567",
    InvalidNumber: "العدد المدخل غير صحيح.",
    NoSelectedLineNumber: "الرجاء تحديد خط الإرسال.",
    EmptyText: "الرجاء إدخال النص.",
    UnknownError: "خطأ غير معروف",
    TryAgain: "الرجاء المحاولة مرة أخرى لاحقاً.",
    NoAccountCharge: "رصيد غير كافٍ",
    NoAccess: "لا تملك صلاحية الوصول.",
    PleasebyeAPlane: "الرجاء شراء باقة.",
    PleaseChargeYourAccount: "الرجاء شحن حسابك.",
    AccessDenied: "تم رفض الوصول.",
    AccessDeniedDescription: "اتصل بالدعم الفني للحصول على مزيد من المعلومات.",
    Error: "خطأ",
    InvalidText: "نص غير صالح",
    InvalidTextContainsLink:
      "الخطوط الخدمية فقط هي التي يمكن أن تحتوي على روابط.",
    NoPhoneToSend: "لا توجد أرقام للإرسال إليها.",
  },
  FORMS: {
    SuccsessFullySended: "حسناً",
    DestinationPhone: "رقم هاتف المستلم",
    TestDestinationPhone: "رقم هاتف الاختبار",
    SourceNumber: "رقم المرسل",
    Text: "النص",
    CharCount: "عدد الأحرف",
    FarsiCharCount: "عدد الأحرف الفارسية",
    EnglishCharCount: "عدد الأحرف الإنجليزية",
    Send: "إرسال",
    SendTime: "وقت الإرسال",
    SendTest: "إرسال تجريبي",
    SendToTestNumber: "إرسال إلى رقم الاختبار",
    SmsCount: "عدد الرسائل",
    SmsLang: "لغة الرسالة",
    Add: "إضافة",
    FromFile: "إضافة من ملف",
    TestNumber: "رقم الاختبار",
    Test: "اختبار",
    ServiceRelated: "خدمي",
    Price: "تكلفة إرسال القائمة البيضاء",
    TotalPrice: "إجمالي التكلفة",
    NumbersCount: "إجمالي عدد الأرقام",
    BlacklistPrice: "تكلفة إرسال القائمة السوداء",
    BlacklistNumbersCount: "عدد القائمة السوداء",
    WhitelistNumbersCount: "عدد القائمة البيضاء",
    IrancellNumbersBlacklistCount: "عدد القائمة السوداء لإيرانسل",
    HamrahavalNumbersBlacklistCount: "عدد القائمة السوداء لهمراه أول",
    IrancellNumbersWhitelistCount: "عدد القائمة البيضاء لإيرانسل",
    HamrahavalNumbersWhitelistCount: "عدد القائمة البيضاء لهمراه أول",
    NumbersCountToSend: "عدد الأرقام الصحيحة",
    Search: "بحث",
    Title: "العنوان",
    RequestTime: "وقت الطلب",
    RequestInformation: "معلومات الطلب",
    CreateNewPhoneBook: "إنشاء دليل هاتف جديد",
    AddPhone: "إضافة أرقام",
    Remove: "حذف",
  },
  unexpected_error: "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.",
  luck_wheel_name: "اسم رمز QR لعجلة الحظ",
  update_video: "إضافة معرض فيديو",
  edit: "تحرير",
  to_top: "من الأعلى",
  to_bottom: "من الأسفل",
  to_left: "من اليمين إلى اليسار",
  to_right: "من اليسار إلى اليمين",
  to_top_right: "من الأسفل إلى اليمين",
  to_top_left: "من الأسفل إلى اليسار",
  to_bottom_right: "من الأعلى إلى اليمين",
  to_bottom_left: "من الأعلى إلى اليسار",
  select_color_gradient: "اختيار لون التدرج",
  select_color_solid: "اختيار لون صلب",
  gradient_direction: "اتجاه التدرج",
  gradient_background: "خلفية التدرج",
  qr_downloaded_successfully: "تم تحميل رمز الاستجابة السريعة بنجاح.",
  logo: "الشعار",
  qr_design_size: "تصميم وحجم رمز الاستجابة السريعة",
  qr_eye_design: "تصميم عين رمز الاستجابة السريعة",
  qr_markout: "هامش الإخراج",
  frame: "الإطار",
  ready_card_samples: "عينات بطاقات الزيارة الجاهزة",
  ready_card_sample: "عينة بطاقة زيارة جاهزة",
  remove_default_info: "إزالة المعلومات الافتراضية",
  select_ready_card: "اختيار بطاقة زيارة جاهزة",
  connection_code: "رمز الاتصال",
  enter_visit_card_info: "إدخال معلومات بطاقة الزيارة",
  info: "المعلومات",
  select_template_design: "اختيار تصميم القالب",
  qr_address: "عنوان رمز الاستجابة السريعة",
  visit_card_name: "اسم بطاقة زيارتك",
  visit_card_name_pro: "اسم بطاقة برو زيارتك",
  download_qr: "تحميل رمز الاستجابة السريعة",
  fast_design: "تصميم سريع",
  professional_design: "تصميم احترافي",
  ai_design: "تصميم بالذكاء الاصطناعي",
  update_qr: "تحديث رمز الاستجابة السريعة",
  fast_design_message:
    "تم نقلك إلى تصميم الرمز السريع. تم إجراء التصميم السابق في هذا القسم.",
  professional_design_message:
    "تم نقلك إلى تصميم الرمز الاحترافي. تم إجراء التصميم السابق في هذا القسم.",
  scan_me: "امسحني",
  visit_card_edited_successfully: "تم تحرير بطاقة زيارتك بنجاح.",
  customer_club_membership: "عضوية نادي العملاء",
  qrland: "أرض الرموز",
  dynamic: "ديناميكي",
  about_us_text:
    "مميزات رمز الاستجابة السريعة الديناميكي:\n✔️ تحرير غير محدود\n✔️ مسح سهل\n✔️ إمكانية تقييد عدد المسح\n✔️ إمكانية إضافة كلمة مرور\n✔️ عرض ومراجعة إحصائيات الزوار\n✔️ تغيير لون مظهر الرمز\n✔️ حفظ المعلومات والأمان\n✔️ إمكانية إضافة صورة وشعار إلى الرمز\n✔️ إمكانية إضافة رمز متخصص حسب احتياج العمل\n✔️ نقل الماسح إلى الروابط والموقع\n✔️ تقديم الرمز ورابط مختصر معاً\n✔️ قابل للاستخدام في جميع الشبكات الاجتماعية (غير متصل ومتصل)\n✔️ قابل للتحميل بأي صيغة مرغوبة\n✔️ قابل للطباعة على أي سطح أو حجم",
  video_gallery: "معرض الفيديو",
  address_text:
    "الرياض، شارع الملك فهد، بعد جسر الملك فهد، زقاق الخالدية، لوحة 6",
  visit_card: "بطاقة زيارة",
  qrland_system: "نظام أرض الرموز",
  qrland_first_system: "أول نظام لبناء رمز الاستجابة السريعة الديناميكي",
  address: "العنوان",
  enter_site_link: "أدخل رابط الموقع المطلوب",
  instagram: "إنستغرام",
  enter_instagram_username: "أدخل اسم المستخدم الخاص بك",
  whatsapp: "واتساب",
  invalid_qr_address: "العنوان المدخل غير صحيح!",
  visit_card_created_successfully: "تم إنشاء بطاقة زيارتك بنجاح.",
  qr_creation_failed: "فشل في إنشاء رمز الاستجابة السريعة!",
  manage_password: "إدارة كلمة المرور",
  hour_limit: "حد الوقت",
  scan_click_limit: "حد عدد المسح/النقر",
  redirect_scanner: "نقل الماسح",
  edit_settings_error: "حدث خطأ أثناء تحرير الإعدادات!",
  next: "التالي",
  add: "إضافة",
  header_color_settings: "إعدادات لون ونص الترويسة",
  select_image: "اختيار صورة",
  enter_qr_address: "أدخل عنوان رمز الاستجابة السريعة الخاص بك",
  qr_idea_title: "فكرة إنشاء رمز الاستجابة السريعة",
  qr_idea: "فكرة الرمز",
  qr_idea_subject: "موضوع إنشاء الرمز",
  confirm_qr_idea: "تأكيد فكرتي للرمز",
  scannable: "قابل للمسح",
  ai_sample: "عينة من إنتاج الذكاء الاصطناعي...",
  scan_warning: "قد لا يُمسح على جميع الأجهزة. في حالة عدم المسح، حاول مجددًا.",
  ai_description:
    "أدخل وصف رمز الاستجابة السريعة المطلوب، وسيقوم الذكاء الاصطناعي بإنشائه لك.",
  attach: "إرفاق",
  remaining: "المتبقي",
  qr_creation: "إنشاء رمز الاستجابة السريعة",
  free: "مجاني",
  select_language_for_request: "اختيار اللغة لكتابة نص الطلب",
  request_text: "نص الطلب",
  request_text_placeholder: "صف رابط الرمز المطلوب...",
  strengthen_text: "تعزيز النص الحالي",
  prompt_idea: "فكرة الأمر",
  try_again: "حاول مجددًا",
  create_qr: "إنشاء رمز الاستجابة السريعة",
  smart_qr_code: "رمز استجابة ذكي",
  regenerate_image: "إعادة إنشاء الصورة",
  updating_qr: "جاري تحديث الرمز...",
  copied: "تم النسخ",
  copy: "نسخ",
  print_qr: "طباعة الرمز",
  print_visit_card: "طباعة بطاقة الزيارة",
  send_link: "إرسال الرابط",
  customer_list: "قائمة العملاء",
  order_list: "قائمة الطلبات",
  reserved_appointments: "المواعيد المحجوزة",
  feedback: "التعليقات",
  request_form: "نموذج الطلب",
  transfer_ownership: "نقل الملكية",
  select_nfc_card: "اختيار بطاقة NFC",
  created_at: "تم الإنشاء",
  last_edit: "آخر تحرير",
  qr_card: "بطاقة الرمز",
  viewed: "تمت المشاهدة",
  see_more: "عرض المزيد",
  download: "تحميل",
  activate: "تفعيل",
  design: "تصميم",
  qr_settings: "إعدادات الرمز",
  deactivate: "إيقاف",
  qr_color_size: "لون وحجم الرمز",
  dots_design_color: "تصميم ولون النقاط",
  eye_design_color: "تصميم ولون العين",
  border_design_color: "تصميم ولون الحدود",
  logo_settings: "إعدادات الشعار",
  download_qr_comment: "تحميل الرمز",
  connection_established: "تم إنشاء الاتصال.",
  show_qr: "عرض الرمز",
  preview: "معاينة",
  user_info: "معلومات المستخدم",
  sms_club_membership: "عضوية نادي الرسائل القصيرة",
  smart_settings: "إعدادات ذكية",
  add_audio_file: "إضافة ملف صوتي",
  back: "رجوع",
  after_click_location: "بعد النقر على الموقع، اختر تطبيق الخرائط الخاص بك.",
  phone_number: "رقم الهاتف",
  auto_display: "عرض تلقائي",
  customer_club: "نادي العملاء",
  auto_download: "تحميل تلقائي",
  save: "حفظ",
  about_us: "من نحن",
  view_more: "عرض المزيد",
  view_less: "عرض أقل",
  audio_file: "ملف صوتي",
  add_video: "إضافة فيديو",
  add_image: "إضافة صورة",
  select_color: "اختيار اللون",
  header_color: "نص الترويسة",
  add_social_networks: "إضافة الشبكات الاجتماعية",
  format: "الصيغة",
  output_size: "حجم الإخراج",
  file_type: "نوع الملف",
  default: "افتراضي",
  qr_download_error: "فشل تحميل الرمز. حاول مجددًا",
  header_color_text_settings: "إعدادات لون ونص الترويسة",
  upload_catalog_images: "رفع صور الكتالوج / البروشور",
  delete: "حذف",
  personal_domain: "نطاق شخصي",
  no_domain_found: "لم يتم العثور على نطاق!",
  enter_domain_address: "يرجى إدخال عنوان النطاق الخاص بك",
  dns_setup_note: "تذكر أنه يجب عليك أولاً إعداد خوادم DNS!",
  attention: "تنبيه: ",
  dns_setup_instruction: "للتسجيل في نطاق شخصي، قم أولاً بإعداد خوادم DNS",
  and: "و",
  setup_on_domain: "على نطاقك.",
  dns_change_time: "(وقت تغيير DNS قد يستغرق حتى 24 ساعة)",
  add_domain: "إضافة نطاق",
  add_personal_domain: "إضافة نطاق شخصي",
  min_characters: "الحد الأدنى لعدد الأحرف المدخلة",
  domain_format:
    "يجب أن يكون نطاق الموقع بالصيغة https://terminalads.com أو terminalads.com.",
  invalid_domain: "النطاق المدخل غير صحيح!",
  domain_added_successfully: "تم إضافة نطاقك بنجاح",
  invalid_dns_settings: "إعدادات DNS غير صحيحة!",
  deleted_successfully: "تم الحذف بنجاح",
  location: "الموقع",
  save_contact: "حفظ جهة الاتصال",
  search: "بحث",
  data_fetch_error: "خطأ في جلب البيانات!",
  error: "خطأ",
  view_qr: "عرض الرمز",
  qr_design: "تصميم الرمز",
  register: "تسجيل",
  terminal_ads: "محطة الإعلانات",
  manage_40_advertising_methods: "إدارة 40 طريقة إعلانية في وقت واحد!",
  ms_khansari: "السيدة خوانساري",
  support: "الدعم",
  comprehensive_advertising_system:
    "النظام الشامل الوحيد لفحص وإدارة الإعلانات عبر الإنترنت",
  terminal_ads_description:
    "تفخر محطة الإعلانات بتواصلها المستمر والمؤثر مع عملائها وجمهورها لفهم احتياجاتهم وتقديم أفضل الحلول. يُعتبر عملاؤنا ومستخدمونا الأوفياء أهم رأس مال لدينا، يليهم فريق الخبراء الفعّال الذي يدعم الشركة بأفكار جديدة وتقنيات حديثة.",
  please_enter_qr_address_correctly: "يرجى إدخال عنوان الرمز بشكل صحيح!",
  server_error: "خطأ في الخادم!",
  please_enter_your_address: "يرجى إدخال عنوانك",
  please_enter_instagram_address: "يرجى إدخال عنوان إنستغرام الخاص بك",
  please_enter_whatsapp_address: "يرجى إدخال عنوان واتساب الخاص بك",
  enter_information: "إدخال المعلومات",
  dynamic_qr: "رمز ديناميكي",
  coming_soon: "قريبًا",
  qr_name: "اسم الرمز",
  for_default_address_leave_empty: "!اتركه فارغًا لاستخدام العنوان الافتراضي",
  default_address: "العنوان الافتراضي",
  sms: "رسالة نصية",
  enter_number_without_zero: "أدخل الرقم بدون صفر.",
  number: "الرقم",
  country_code: "رمز الدولة:",
  sms_text: "نص الرسالة",
  complete_sms_fields_correctly: "يرجى تعبئة حقول الرسائل النصية بشكل صحيح!",
  qr_code_created_successfully:
    "تم إنشاء رمز الاستجابة السريعة الخاص بك بنجاح.",
  chat: "الدردشة",
  call: "الاتصال",
  please_enter_username: "يرجى إدخال اسم المستخدم الخاص بك.",
  username: "اسم المستخدم",
  sample_menu: "قائمة عينة",
  online_menu_name: "اسم قائمتك عبر الإنترنت",
  online_menu_name_short: "اسم القائمة عبر الإنترنت",
  enter_menu_information: "إدخال معلومات القائمة",
  select_sample_menu: "اختيار قائمة عينة",
  select_ready_menu: "اختيار قائمة جاهزة",
  online_sales: "المبيعات عبر الإنترنت",
  sales_settings: "إعدادات المبيعات",
  photo_gallery: "معرض الصور",
  fast_food1: "الوجبات السريعة 1",
  fast_food2: "الوجبات السريعة 2",
  products: "المنتجات",
  pizzas: "البيتزات",
  pizza_rust_beef: "بيتزا روست بيف",
  italian_pizza_with_beef: "🤩 بيتزا إيطالية مع لحم البقر",
  italian_pizza_dough_30cm: "عجينة بيتزا إيطالية 30 سم",
  "100g_shredded_beef": "100 غرام لحم بقر مفروم",
  mushroom_bell_pepper: "فطر، فلفل رومي",
  black_olives: "زيتون أسود",
  pizza_chicken_mushroom: "بيتزا دجاج وفطر",
  classic_40cm: "🍕 كلاسيك 40 سم",
  fresh_tomato_sauce: "صلصة طماطم طازجة، جبن، فيليه دجاج، فطر، زعتر جبلي",
  pizza_meat_mushroom: "بيتزا لحم وفطر",
  meat_pizza_with_mushroom: "🥰 بيتزا لحم مفروم مع فطر",
  pizza_vegetables: "بيتزا خضار",
  american_vegetable_pizza: "🍕 بيتزا خضار أمريكية",
  american_pizza_dough:
    "عجينة بيتزا أمريكية، ذرة، فطر، زيتون، طماطم، بصل، فلفل، جبن بيتزا",
  special_pizza: "بيتزا خاصة",
  american_special_pizza: "بيتزا خاصة أمريكية",
  pizza_bolognese: "بيتزا بولونيز",
  one_person_23cm: "(فردي) عجينة بيتزا 23 سم 🤌",
  pepperoni_pizza: "بيتزا بيبروني",
  one_person_23cm_dough: "(فردي) عجينة بيتزا 23 سم",
  bacon_pizza: "بيتزا بيكون",
  one_person_23cm_explosion: "(فردي) عجينة بيتزا 23 سم 💥",
  mixed_pizza: "بيتزا مشكلة",
  one_person_23cm_mixed: "(فردي) عجينة بيتزا 23 سم 🤭",
  american_steak_pizza: "بيتزا ستيك أمريكية",
  one_person_23cm_steak: "(فردي) 23 سم 💥",
  burgers: "الهمبرغر",
  cheese_burger: "تشيز برغر",
  with_french_fries: "🤩 مع بطاطس مقلية",
  "2_beef_burgers_150g": "قطعتان برغر لحم بقر 150 غرام",
  special_sauce_gouda_cheese: "صلصة خاصة، جبن غودا",
  pickles_lettuce_tomato: "مخلل، خس، طماطم",
  special_sauce: "صلصة خاصة",
  burger: "برغر",
  pure_meat_with_special_sauce: "😍 لحم خالص مع صلصة خاصة",
  chicken_burger: "تشيكن برغر",
  grilled_chicken_burger_with_cheese: "برغر دجاج مشوي مع جبن",
  spicy_burger: "برغر حار",
  beef_with_spicy_sauce: "لحم بقر مع صلصة حارة",
  double_burger: "دبل برغر",
  "150g_beef": "لحم بقر 150 غرام",
  royal_burger: "رويال برغر",
  "150g_beef_emoji": "150 غرام لحم بقر 🍔",
  mushroom_burger: "برغر فطر",
  "150g_beef_mushroom": "لحم بقر 150 غرام",
  mushroom_burger_grilled: "ماشروم برغر",
  "100_percent_grilled_beef": "لحم بقر مشوي 100% 🤩",
  fried_burger: "برغر مقلي",
  "100_percent_grilled_fried": "لحم بقر مشوي ومقلي 100% 👌",
  fried: "مقلي",
  fried_chicken: "دجاج مقلي",
  "3_piece_fried_chicken": "😍 دجاج مقلي ثلاث قطع",
  "3_fried_chicken_pieces": "3 قطع دجاج مقلي",
  "120_150g_french_fries": "120-150 غرام بطاطس مقلية",
  enter_product_information: "إدخال معلومات المنتج",
  product_name: "اسم منتجك",
  product_name_short: "اسم المنتج",
  complete_features_from_image: "استكمال الميزات من صورة المنتج",
  skip_step: "تخطي الخطوة",
  product_and_information: "المنتج والمعلومات",
  product_introduction: "تقديم المنتج",
  shiva_waves: "شيفا أمواج",
  think_best: "فكر في الأفضل...",
  iran_zanjan_abhar:
    "إيران، زنجان، أبهر، المنطقة الصناعية الشريف، بجانب محطة الكهرباء 63/20",
  video_gallery_description: "تفضل بزيارة مقاطع الفيديو الخاصة بنا.",
  gallery: "المعرض",
  welcome: "ترحيب",
  invalid_address: "العنوان المدخل غير صحيح!",
  product_created_successfully: "تم إنشاء منتجك بنجاح.",
  qr_visit_card_edited_successfully: "تم تحرير بطاقة الزيارة الخاصة بك بنجاح.",
  change_header_color: "تغيير لون الترويسة",
  change_body_color: "تغيير لون الجسم",
  change_button_colors: "تغيير ألوان الأزرار",
  change_text_colors: "تغيير ألوان النصوص",
  gradient_colors: "ألوان التدرج",
  color_direction: "اتجاه اللون",
  first_color: "اللون الأول",
  second_color: "اللون الثاني",
  color: "اللون",
  text_color: "لون النص",
  from_top: "من الأعلى",
  from_bottom: "من الأسفل",
  from_left_to_right: "من اليسار إلى اليمين",
  from_right_to_left: "من اليمين إلى اليسار",
  from_top_to_left: "من الأعلى إلى اليسار",
  from_top_to_right: "من الأعلى إلى اليمين",
  from_bottom_to_left: "من الأسفل إلى اليسار",
  from_bottom_to_right: "من الأسفل إلى اليمين",
  sharing: "المشاركة",
  business_shop: "أعمال / متجر",
  corporate_organizational: "شركة / تنظيمية",
  customer_contact: "الاتصال بالعميل",
  information: "معلومات",
  miscellaneous: "متنوع",
  link: "رابط",
  margin: "الهامش",
  width: "العرض",
  height: "الارتفاع",
  background_color: "لون الخلفية",
  gradient_color: "لون التدرج",
  linear: "خطي",
  radial: "دائري",
  color_rotation: "دوران اللون",
  background_color_label: "لون الخلفية",
  dots_color: "لون النقاط",
  dots_color_label: "لون النقاط",
  eye_colors: "ألوان العين",
  separate_colors_for_each_eye: "ألوان منفصلة لكل عين",
  current_mode: "الوضع الحالي:",
  separate_colors: "ألوان منفصلة",
  same_color: "لون واحد",
  all_eyes_color: "لون جميع العيون",
  top_right_eye: "العين العلوية اليمنى",
  top_left_eye: "العين العلوية اليسرى",
  bottom_left_eye: "العين السفلية اليسرى",
  upload_logo: "رفع الشعار",
  hide_background_dots: "إخفاء النقاط خلف الشعار",
  logo_size: "حجم الشعار",
  logo_margin: "هامش الشعار",
  qr_accuracy: "دقة رمز الاستجابة السريعة",
  mode: "الوضع",
  error_correction_level: "مستوى تصحيح الخطأ",
  numeric: "رقمي",
  alphanumeric: "أبجدي رقمي",
  byte: "بايت",
  apply_changes: "تطبيق التغييرات",
  please_click_apply_changes:
    'يرجى النقر على "تطبيق التغييرات" بعد اختيار التعديلات المطلوبة.',
  created_qr_codes: "رموز الاستجابة السريعة المُنشأة",
  square_ratio: "1:1 (مربع)",
  image_upload_error: "خطأ في رفع الصورة!",
  visit_card_name_label: "اسم بطاقة الزيارة",
  sms_membership_message: "رسالة عضوية نادي العملاء عبر الرسائل النصية",
  admin_menu: "قائمة الإدارة",
  user_menu: "قائمة المستخدم العادي",
  guide_tooltip: "دليل",
  close: "إغلاق",
  browser_video_support_error: "متصفحك لا يدعم أي صيغ فيديو.",
  video_loading_error: "خطأ في تحميل الفيديو (قد يكون الوصول محدودًا).",
  click_more_for_videos: "انقر على المزيد لمشاهدة المزيد من الفيديوهات.",
  more_info: "معلومات أكثر",
  more: "المزيد",
  add_user_guide: "إضافة دليل المستخدمين",
  edit_user_guide: "تحرير دليل المستخدمين",
  display_info: "عرض المعلومات",
  element: "العنصر",
  disable_attach: "تعطيل الإرفاق للتناسب مع الصفحة",
  view: "عرض",
  guide: "دليل",
  details: "التفاصيل",
  guide_images: "صور الدليل",
  guide_videos: "فيديوهات الدليل",
  faq: "الأسئلة الشائعة",
  data_preload_error: "خطأ في تحميل البيانات المسبق:",
  guide_not_found: "لم يتم العثور على الدليل. يرجى إنشاء دليل أولاً.",
  delete_guide_question: "حذف الدليل؟",
  delete_guide_error: "خطأ في حذف الدليل!",
  unknown_file_type: "نوع الملف غير معروف:",
  content_type_error: "خطأ في استلام نوع المحتوى:",
  video: "فيديو",
  image: "صورة",
  guide_data_error: "خطأ في استلام بيانات الدليل:",
  add_iranian_stores: "إضافة متاجر إيرانية",
  add_foreign_stores: "إضافة متاجر أجنبية",
  bazaar: "بازار",
  myket: "مايكت",
  app_store: "آب ستور",
  google_play: "غوغل بلاي",
  samsung_store: "متجر سامسونغ",
  xiaomi_store: "متجر شاومي",
  vivo_store: "متجر فيفو",
  amazon_store: "متجر أمازون",
  bazaar_app: "تطبيق بازار",
  bazaar_link_placeholder: "أدخل رابط التطبيق في بازار",
  bazaar_link_hint:
    "أدخل رابط بازار صالح (مثال: https://cafebazaar.ir/app/com.abankefarda)",
  myket_app: "تطبيق مايكت",
  myket_link_placeholder: "أدخل رابط التطبيق في مايكت",
  myket_link_hint:
    "أدخل رابط مايكت صالح (مثال: myket://details?id=com.example)",
  app_store_app: "تطبيق آب ستور",
  app_store_link_placeholder: "أدخل رابط التطبيق في آب ستور",
  app_store_link_hint:
    "أدخل رابط آب ستور صالح (مثال: https://apps.apple.com/us/app/appname/id123456789)",
  google_play_app: "تطبيق غوغل بلاي",
  google_play_link_placeholder: "أدخل رابط التطبيق في غوغل بلاي",
  google_play_link_hint:
    "أدخل رابط غوغل بلاي صالح (مثال: https://play.google.com/store/apps/details?id=com.example)",
  samsung_store_app: "تطبيق متجر سامسونغ",
  samsung_store_link_placeholder: "أدخل رابط التطبيق في متجر سامسونغ",
  samsung_store_link_hint:
    "أدخل رابط متجر سامسونغ صالح (مثال: https://galaxy.store/appname)",
  xiaomi_store_app: "تطبيق متجر شاومي",
  xiaomi_store_link_placeholder: "أدخل رابط التطبيق في متجر شاومي",
  xiaomi_store_link_hint: "أدخل رابط متجر شاومي صالح",
  vivo_app_store: "متجر تطبيقات فيفو",
  vivo_app_store_app: "تطبيق متجر تطبيقات فيفو",
  vivo_app_store_link_placeholder: "أدخل رابط التطبيق في متجر تطبيقات فيفو",
  vivo_app_store_link_hint: "أدخل رابط متجر تطبيقات فيفو صالح",
  amazon_store_app: "تطبيق متجر أمازون",
  amazon_store_link_placeholder: "أدخل رابط التطبيق في متجر أمازون",
  amazon_store_link_hint: "أدخل رابط متجر أمازون صالح",
  iranian_store: "متجر إيراني",
  foreign_store: "متجر أجنبي",
  personal_store: "متجر شخصي",
  image_logo: "صورة/شعار",
  image_gallery: "معرض الصور",
  header_image: "صورة الترويسة",
  template_background_image: "صورة خلفية القالب",
  background_image: "صورة الخلفية",
  background_image_alt: "صورة الخلفية",
  logo_upload: "رفع الشعار",
  welcome_image: "صورة الترحيب",
  welcome_image_logo_upload: "رفع صورة/شعار الترحيب",
  loading_animation: "رسوم تحميل متحركة",
  preview_welcome_page: "معاينة صفحة الترحيب",
  max_background_size: "الحد الأقصى لحجم كل صورة خلفية هو 2 ميغابايت.",
  max_logo_size: "الحد الأقصى لحجم كل شعار هو 2 ميغابايت.",
  scale_from_center: "التكبير من المركز",
  slide_from_left: "الدخول من اليسار",
  slide_from_top: "الدخول من الأعلى",
  fade: "التلاشي",
  select_music_card: "اختيار بطاقة الموسيقى",
  show_audio: "عرض الصوت",
  hide_audio: "إخفاء الصوت",
  add_voice: "إضافة صوت",
  max_files_limit: "لا يُسمح لك باختيار أكثر من {count} ملف!",
  files_not_allowed: "الملفات غير مسموحة!",
  voice_gallery: "معرض الصوت",
  edit_voice: "تحرير الصوت",
  list: "القائمة",
  file_name: "اسم الملف",
  title: "العنوان",
  description: "الوصف",
  selectdate: "اختيار التاريخ",
  background: "الخلفية",
  text: "النص",
  delete_audio_confirm: "هل أنت متأكد من حذف الملف الصوتي من معرضك؟",
  add_voice_gallery: "إضافة معرض صوتي",
  gallery_number: "المعرض",
  delete_confirm: "هل أنت متأكد من الحذف",
  confirm: "؟",
  voice_gallery_title_hint: "يرجى إدخال عنوان معرضك الصوتي.",
  voice_gallery_title: "العنوان",
  voice_gallery_subtitle_hint: "يرجى إدخال العنوان الفرعي لمعرضك الصوتي.",
  voice_gallery_subtitle: "العنوان الفرعي للمعرض الصوتي",
  voice_gallery_subtitle_alt: "العنوان الفرعي",
  website_address_hint: "يرجى إدخال عنوان موقعك الإلكتروني.",
  website_address: "عنوان الموقع الإلكتروني",
  about_voice_gallery: "حول المعرض",
  about_voice_gallery_alt: "حول المعرض",
  button_name_hint: "يرجى إدخال اسم الزر.",
  button_name: "اسم الزر",
  domain_format_hint:
    "يجب أن يكون نطاق الموقع بصيغة https://terminalads.com أو terminalads.com.",
  about_us_alt: "من نحن",
  add_default_form: "إضافة نموذج افتراضي",
  delete_all: "حذف الكل",
  validation_active: "التحقق: مفعل",
  validation_inactive: "التحقق: معطل",
  validation: "التحقق",
  clear_form: "مسح النموذج",
  status: "الحالة",
  active: "مفعل",
  inactive: "معطل",
  optional: "اختياري",
  required: "إلزامي",
  question_title: "العنوان",
  question_title_hint: "أدخل عنوان السؤال",
  options_hint: "اكتب الخيارات ثم اضغط إنتر للإضافة",
  options: "الخيارات",
  add_suggested_form: "إضافة نموذج طلب مقترح",
  save_changes: "حفظ التغييرات",
  add_request_field: "إضافة حقل طلب",
  select_form_type: "اختيار نوع النموذج",
  select_form_type_placeholder: "اختيار نوع النموذج",
  dropdown: "قائمة منسدلة",
  text_field: "حقل نصي",
  number_field: "حقل رقمي",
  textarea_field: "حقل نص مفتوح",
  date_field: "حقل تاريخ",
  field_name_required: "اسم الحقل لا يمكن أن يكون فارغًا",
  field_name: "اسم الحقل",
  add_field_name: "إضافة اسم الحقل",
  field_label: "نص التسمية",
  add_field_label: "إضافة تسمية الحقل",
  advanced_settings: "الإعدادات المتقدمة",
  select_input_pattern: "اختيار نمط الإدخال",
  select_input_pattern_placeholder: "اختيار نمط الإدخال",
  max_characters: "الحد الأقصى لعدد الأحرف",
  min_input_error: "الحد الأدنى للإدخال يجب أن يكون 0",
  name_field: "الاسم",
  field_type: "نوع الحقل",
  persian_limit: "قيد اللغة الفارسية",
  family_name: "اسم العائلة",
  mobile_number: "رقم الجوال",
  number_limit: "قيد الرقم",
  national_code: "الرمز الوطني",
  meli_code: "الرمز الوطني",
  email: "البريد الإلكتروني",
  email_limit: "قيد البريد الإلكتروني",
  dropdown_field: "قائمة منسدلة",
  english_limit: "قيد اللغة الإنجليزية",
  mix_per_eng_limit: "قيد اللغتين الفارسية والإنجليزية",
  site_limit: "قيد الموقع",
  form_added_successfully: "تمت إضافة النموذج الجديد بنجاح",
  form_updated_successfully: "تم تحديث النموذج بنجاح",
  delete_item_confirm: "هل أنت متأكد من حذف العنصر؟",
  default_form_added_successfully: "تمت إضافة النموذج الافتراضي بنجاح",
  resources_upload_error: "حدث خطأ أثناء رفع الموارد",
  update_value_if_duplicate: "تحديث القيمة إذا كانت مكررة",
  first_tab: "التبويب الأول",
  display_count: "عدد العرض",
  buy_renew_qr_instruction:
    "لشراء/تجديد رمز الاستجابة السريعة، انقر على زر مدة الانتهاء.",
  days_until_expiry: "أيام حتى الانتهاء",
  expired: "منتهي الصلاحية",
  no_qr_to_display: "لا توجد رموز استجابة سريعة لعرضها!",
  second_tab: "التبويب الثاني",
  total_qr_codes: "إجمالي رموز الاستجابة السريعة",
  select_all: "تحديد الكل",
  selected_qr_codes_count: "عدد رموز الاستجابة السريعة المحددة",
  qr_codes_count: "عدد رموز الاستجابة السريعة",
  group_renewal_instruction:
    "لتجديد جماعي، حدد رموز الاستجابة السريعة المطلوبة.",
  no_qr_found_with_filters:
    "لم يتم العثور على أي رمز استجابة سريعة بهذه الفلاتر!",
  qr_codes_count_label: "عدد رموز الاستجابة السريعة:",
  renew_qr: "تجديد رمز الاستجابة السريعة",
  days: "أيام",
  buy_now: "أشتري الآن!",
  buy_now_label: "أشتري",
  add_discount_code: "إضافة رمز الخصم",
  use_discount_code: "استخدام رمز الخصم",
  discount_code: "رمز الخصم",
  submit: "إرسال",
  my_qr_list: "قائمة رموزي",
  group_renewal: "تجديد جماعي",
  row: "الصف",
  type: "النوع",
  clicks: "الزيارات",
  created_at_diff: "وقت الإنشاء",
  updated_at_diff: "وقت التحديث",
  table_view: "عرض جدولي",
  normal_view: "عرض عادي",
  no_qr_or_id_selected: "لم يتم تحديد أي رمز أو معرف!",
  qr_updated_successfully: "تم تحديث رمز الاستجابة السريعة بنجاح.",
  qr_update_error: "خطأ في تحديث رمز الاستجابة السريعة!",
  no_qr_selected: "لم يتم تحديد أي رمز استجابة سريعة!",
  no_qr_code_selected: "لم يتم تحديد أي رمز استجابة سريعة!",
  success: "نجاح",
  qrs_upgraded_successfully: "تم ترقية رموزك بنجاح.",
  qr_renewal_error: "حدثت مشكلة في طلب تجديد رمز الاستجابة السريعة!",
  changed_successfully: "تم التغيير بنجاح.",
  error_occurred: "حدث خطأ!",
  no_tariff_exists: "لا توجد تعرفة!",
  qr_upgraded_successfully: "تم ترقية رمزك بنجاح.",
  check_account_balance: "يرجى التحقق من رصيد حسابك وحاول مرة أخرى لاحقًا.",
  group_renewal_price_error: "خطأ في استلام سعر التجديد الجماعي!",
  qr_count_error: "خطأ في استلام عدد رموز الاستجابة السريعة!",
  no_qr_for_renewal: "لا توجد رموز استجابة سريعة للتجديد!",
  table_pagination: "ترقيم الصفحات أعلى الجدول",
  virtual_scroll_display: "عرض البيانات بتمرير افتراضي",
  popups_shared_components: "النوافذ المنبثقة والمكونات المشتركة",
  edit_qr_address: "تحرير عنوان رمز الاستجابة السريعة",
  please_enter_correct_address: "يرجى إدخال عنوان صحيح",
  successfully_edited: "تم التحرير بنجاح.",
  error_editing_qr_address: "خطأ في تحرير عنوان رمز الاستجابة السريعة!",
  go_to_page: "الانتقال إلى الصفحة",
  page_from_to: "الصفحة {current} من {last}",
  display: "عرض",
  to: "إلى",
  from: "من",
  show: "عرض",
  page_status: "الصفحة {current} من {total}",
  until: "حتى",
  successfully_completed: "تم بنجاح",
  problem_occurred: "حدثت مشكلة",
  download_failed: "فشل التحميل",
  audio_file_default: "ملف صوتي",
  memory_release: "تحرير الذاكرة",
  seek_music_comment: "افتراضيًا، هذا الموسيقى أو أي شيء يتم البحث عنه",
  all: "الكل",
  create_podcast: "إنشاء بودكاست",
  add_link: "إضافة رابط",
  upload_file: "رفع ملف",
  file_list: "قائمة الملفات",
  count: "العدد",
  select_category: "اختيار الفئة",
  after_typing_enter: "بعد الكتابة، اضغط إنتر.",
  no_image_available: "لا توجد صورة",
  no_image_found: "لم يتم العثور على صورة!",
  for_adding_file_use_upload_center:
    "لإضافة ملف، استخدم حقل رفع الصور أو مركز الرفع",
  ai_story_creation_description:
    "أدخل قصتك، وسيقوم الذكاء الاصطناعي بإنشائها لك",
  create_new_podcast: "إنشاء بودكاست جديد",
  show_audio_file: "عرض ملف الصوت",
  cancel: "إلغاء",
  no_audio_in_category: "لا توجد ملفات صوتية في هذه الفئة",
  health_apple: "تفاحة الصحة",
  standard: "معيار",
  arshia_badge: "شارة أرشيا",
  home_appliances_association: "جمعية الأجهزة المنزلية",
  energy_label: "تسمية الطاقة",
  select_gold_purity_first: "للحصول على السعر، حدد عيار الذهب أولاً",
  gold_price_service: "خدمة استلام سعر الذهب",
  rahvard: "راهورد",
  to_change_gold_service_go_to_assets:
    "لتبديل خدمة سعر الذهب، اذهب إلى قسم الأصول",
  gold: "ذهب",
  purity: "العيار",
  rial: "ريال",
  final_product_price: "سعر المنتج النهائي",
  show_images_right_side: "عرض الصور على الجانب الأيمن",
  show_as_slider: "العرض كشريط تمرير.",
  show_as_grid: "العرض كشبكة.",
  show_as_second_mode: "العرض كالوضع الثاني.",
  gallery_name: "اسم المعرض",
  change_gallery_name: "تغيير اسم المعرض",
  add_photo: "إضافة صورة",
  select_photo: "اختيار صورة",
  show_image: "عرض الصورة",
  selected_photo: "الصورة المحددة",
  to_use_ready_images_search_category_or_product:
    "لاستخدام الصور الجاهزة، ابحث عن الفئة أو المنتج من الحقول أعلاه.",
  max_file_size_2mb: "الحد الأقصى لحجم كل ملف هو 2 ميغابايت.",
  drag_and_drop_to_upload_or: "اسحب وأفلت للرفع أو",
  here: "هنا",
  click: "انقر",
  to_use_external_image_link_fill_fields:
    "لاستخدام صورة برابط خارجي، املأ الحقول أدناه",
  image_url_hint: "عنوان (رابط) الصورة المطلوبة.",
  image_url: "رابط الصورة",
  add_new_gallery: "إضافة معرض جديد",
  create_image: "إنشاء صورة",
  ready_images: "صور جاهزة",
  edit_image: "تحرير الصورة",
  enter_valid_link: "أدخل رابطًا صحيحًا.",
  max_background_image_size_2mb:
    "الحد الأقصى لحجم كل صورة خلفية هو 2 ميغابايت.",
  uploaded_successfully: "تم الرفع بنجاح.",
  banner: "لافتة",
  question: "سؤال",
  selected_question: "السؤال المحدد",
  answer: "إجابة",
  add_question: "إضافة سؤال",
  selected_blog: "المدونة المحددة",
  icon: "أيقونة",
  select_icon: "اختيار أيقونة",
  add_blog: "إضافة مدونة",
  post: "منشور",
  selected_services: "الخدمات المحددة",
  add_new_post: "إضافة منشور جديد",
  add_new_services: "إضافة خدمات جديدة",
  add_new_service: "إضافة خدمة جديدة",
  domain_must_be_https_or_http:
    "يجب أن يكون نطاق الموقع بصيغة https://terminalads.com أو terminalads.com.",
  id: "المعرف",
  images: "الصور",
  tags: "العلامات",
  print_type: "نوع الطباعة",
  user: "المستخدم",
  user_shipping_info: "معلومات الشحن للمستخدم",
  qr_short_link: "رابط مختصر لرمز الاستجابة السريعة",
  delivery_method: "طريقة التوصيل",
  delivery_at_company: "التوصيل في الشركة",
  delivery_by_post: "إرسال بالبريد",
  post_cost_and_tax_warning:
    "عند التسجيل، سيتم خصم تكلفة البريد و10% ضريبة من محفظتك.",
  shipping_info: "معلومات الشحن",
  continue_shopping: "متابعة التسوق",
  complete_shopping: "إتمام الشراء",
  select_free_nfc_card: "اختيار بطاقة NFC مجانية",
  order_custom_nfc_card: "طلب بطاقة NFC مخصصة",
  buy_qr_equipment: "شراء معدات رمز الاستجابة السريعة",
  vertical: "عمودي",
  horizontal: "أفقي",
  card_type: "نوع البطاقة",
  tag: "علامة",
  select: "اختيار",
  order_card: "طلب البطاقة",
  available: "متوفر",
  unavailable: "غير متوفر",
  for_initial_loading: "للتحميل الأولي",
  already_have_free_nfc_message:
    "لقد حصلت بالفعل على NFC مجاني لهذا الرمز. لتغيير البطاقة، اشترِ بطاقة مخصصة.",
  nfc_in_delivery_process_message:
    "لقد سجلت NFC مجاني وهو في عملية التوصيل. للتغيير، اشترِ بطاقة مخصصة.",
  free_nfc_card_warning_message:
    "عزيزي العميل: بطاقات NFC المجانية مطبوعة مسبقًا، لذا سيتم تغيير رمزك. إذا استخدمته، اشترِ بطاقة مخصصة.",
  select_card: "اختيار البطاقة",
  free_card_selection_conditions: "شروط اختيار البطاقة المجانية",
  confirm_and_select: "تأكيد واختيار",
  registered_successfully: "تم التسجيل بنجاح.",
  error_registering_nfc_order: "خطأ في تسجيل طلب بطاقة NFC!",
  nfc_physical_card_orders: "طلبات بطاقات NFC الفيزيائية",
  buy_equipment: "شراء المعدات",
  select_quantity: "اختيار الكمية",
  ready_samples: "عينات جاهزة",
  upload_custom_design: "رفع تصميم مخصص",
  select_ready_card_image: "اختيار صورة بطاقة جاهزة",
  select_card_front_image: "اختيار صورة وجه البطاقة",
  select_card_back_image: "اختيار صورة ظهر البطاقة",
  nfc_card_image: "صورة بطاقة NFC",
  add_quantity: "إضافة كمية",
  total_price: "السعر الإجمالي",
  price_with_discount: "السعر مع الخصم",
  shipping_cost: "تكلفة الشحن",
  your_profit_from_purchase: "ربحك من الشراء",
  discount: "الخصم",
  ten_percent_tax_will_be_added: "سيتم إضافة 10% ضريبة إلى المبلغ النهائي.",
  payable_amount: "المبلغ المستحق",
  continue: "متابعة",
  Confirm_code: "تأكيد الرمز",
  form_success_message: "تم استلام نموذجك بنجاح",
  refill_form_message: "إعادة ملء النموذج",
  Enter_the_sent_code: "أدخل الرمز المرسل",
  SUBMIT_FORM: "إرسال النموذج",
  enter_phone_number: "أدخل رقم هاتفك",
  order_registered_successfully: "تم تسجيل طلبك بنجاح.",
  smart_creation: "إنشاء ذكي",
  automatic_creation: "إنشاء تلقائي",
  business_name: "اسم الأعمال",
  example_household_goods: "مثال: أدوات منزلية",
  organization_name: "اسم المنظمة",
  example_tech_company: "مثال: شركة تكنولوجيا متقدمة",
  minimum_two_characters_required: "يجب إدخال حرفين على الأقل!",
  maximum_100_characters_allowed: "الحد الأقصى 100 حرف",
  latin_name_qr_address: "الاسم اللاتيني (عنوان رمز الاستجابة السريعة)",
  example_advanced_tech: "مثال: advanced-tech",
  only_english_numbers_dash_allowed:
    "مسموح فقط بالحروف الإنجليزية والأرقام والشرطة",
  maximum_50_characters_allowed: "الحد الأقصى 50 حرفًا",
  latin_name_goes_after_domain: "يأتي الاسم اللاتيني بعد النطاق",
  select_logo_and_store_product_image: "اختيار الشعار وصورة المتجر/المنتج",
  select_logo: "اختيار الشعار",
  file_size_must_be_less_than_2mb: "يجب أن يكون حجم الملف أقل من 2 ميغابايت",
  for_buying_renewing_qr_click_expiry_button:
    "لشراء/تجديد رمز الاستجابة السريعة، انقر على زر مدة الانتهاء.",
  for_group_renewal_select_desired_qr_codes:
    "لتجديد جماعي، حدد رموز الاستجابة السريعة المطلوبة.",
  no_qr_found_with_these_filters:
    "لم يتم العثور على أي رمز استجابة سريعة بهذه الفلاتر!",
  i_buy: "أشتري",
  visits: "الزيارات",
  creation_time: "وقت الإنشاء",
  edit_time: "وقت التحرير",
  enter_business_card_name_correctly: "أدخل اسم بطاقة الأعمال بشكل صحيح!",
  are_you_sure_delete_qr: "هل أنت متأكد من حذف رمز الاستجابة السريعة؟",
  qr_deleted_successfully: "تم حذف رمز الاستجابة السريعة بنجاح.",
  are_you_sure_deactivate_qr: "هل أنت متأكد من إيقاف رمز الاستجابة السريعة؟",
  are_you_sure_activate_qr: "هل أنت متأكد من تفعيل رمز الاستجابة السريعة؟",
  deactivated: "متوقف",
  qr_successfully: "رمز الاستجابة السريعة بنجاح",
  successfully: "تم",
  user_transferred_successfully: "تم نقل المستخدم بنجاح",
  problem_occurred_in_transfer: "حدثت مشكلة في النقل!",
  error_in_user_transfer: "خطأ في نقل المستخدم!",
  qr_business_card_edited_successfully:
    "تم تحرير بطاقة الأعمال الخاصة بك بنجاح.",
  group_qr_renewal: "تجديد جماعي لرموز الاستجابة السريعة",
  select_desired_duration: "اختر المدة المطلوبة",
  total_count: "العدد الإجمالي",
  final_amount: "المبلغ النهائي",
  ten_percent_vat_will_be_added:
    "سيتم إضافة 10% ضريبة القيمة المضافة إلى المبلغ أعلاه.",
  pay_and_upgrade: "الدفع والترقية",
  no_tariff_for_this_period: "لا توجد تعرفة لهذه الفترة!",
  selected: "محدد",
  total_amount: "المبلغ الإجمالي",
  final_amount_with_discount: "المبلغ النهائي مع الخصم",
  add_qr: "إضافة رمز استجابة سريعة",
  actions: "الإجراءات",
  filter_type: "فلتر النوع",
  start_from: "البدء من",
  search_in_id: "البحث في المعرف",
  filter_user: "فلتر المستخدم",
  clear_filters: "مسح الفلاتر",
  send_sms: "إرسال رسالة نصية",
  selected_pattern: "النمط المحدد",
  send: "إرسال",
  bulk_download: "تحميل جماعي",
  one_month_renewal: "تجديد شهري",
  three_month_renewal: "تجديد ثلاثة أشهر",
  six_month_renewal: "تجديد ستة أشهر",
  one_year_renewal: "تجديد سنوي",
  business_card: "بطاقة أعمال",
  product_label: "تسمية المنتج",
  restaurant_menu: "قائمة المطعم",
  event_ticket: "تذكرة الحدث",
  brochure: "كتيب",
  flyer: "نشرات",
  poster: "ملصق",
  catalog: "كتالوج",
  newsletter: "نشرة إخبارية",
  organization_name_hint: "يرجى إدخال اسم منظمتك.",
  organization_name_label: "اسم المنظمة",
  sub_organization_hint: "يرجى إدخال الاسم الفرعي للمنظمة.",
  sub_organization_label: "وصف الاسم الفرعي للمنظمة",
  user_name_hint: "يرجى إدخال اسمك.",
  user_name_label: "الاسم واللقب",
  work_field_hint: "يرجى إدخال منصبك الوظيفي.",
  work_field_label: "المنصب",
  mobile_number_hint: "يرجى إدخال رقمك.",
  mobile_number_label: "رقم الجوال",
  phone_number_hint: "يرجى إدخال رقم الهاتف.",
  phone_number_label: "رقم الهاتف",
  email_hint: "يرجى إدخال بريدك الإلكتروني.",
  email_label: "البريد الإلكتروني",
  fax_hint: "يرجى إدخال فاكس الشركة.",
  fax_label: "فاكس الشركة",
  website_hint: "يرجى إدخال موقع الشركة.",
  website_label: "موقع الشركة",
  postal_code_hint: "يرجى إدخال الرمز البريدي.",
  postal_code_label: "الرمز البريدي",
  copyright_hint: "يرجى إدخال نص حقوق النشر في التذييل.",
  copyright_label: "نص حقوق النشر",
  address_hint: "يرجى إدخال عنوانك.",
  address_label: "العنوان",
  add_more_info: "أضف المزيد من المعلومات المطلوبة:",
  edit_location: "تحرير",
  add_location: "إضافة",
  delete_location: "حذف الموقع",
  about_us_label: "من نحن",
  search_address: "البحث عن العنوان:",
  northern_coordinates: "إحداثيات شمالية",
  eastern_coordinates: "إحداثيات شرقية",
  select_address_on_map: "اختيار العنوان على الخريطة",
  location_not_found: "لم يتم العثور على الموقع.",
  text_label: "النص",
  number_label: "الرقم",
  website_address_label: "عنوان الموقع",
  location_label: "الموقع",
  mobile_viewer_title: "عارض الجوال",
  visit_theme_two_title: "ثيم بطاقة الزيارة الثاني",
  visit_theme_flipped_title: "ثيم بطاقة الزيارة المقلوب",
  flip_card: "قلب البطاقة",
  flip_card_description: "لعرض المزيد من المعلومات، اقلب البطاقة",
  share_contacts: "مشاركة جهات الاتصال",
  close_share: "إغلاق المشاركة",
  card_front: "وجه البطاقة",
  card_back: "ظهر البطاقة",
  flip_to_back: "القلب إلى الخلف",
  flip_to_front: "القلب إلى الأمام",
  swipe_to_flip: "اسحب للقلب",
  swipe_left: "اسحب يسارًا",
  swipe_right: "اسحب يمينًا",
  expand_card: "توسيع البطاقة",
  contract_card: "تصغير البطاقة",
  view_details: "عرض التفاصيل",
  hide_details: "إخفاء التفاصيل",
  social_media_share: "مشاركة وسائل التواصل",
  contact_actions: "إجراءات الاتصال",
  card_actions: "إجراءات البطاقة",
  floating_menu: "قائمة عائمة",
  close_menu: "إغلاق القائمة",
  open_menu: "فتح القائمة",
  choice_gallery: "المعرض المختار",
  choice_video: "اختيار الفيديو",
  url_video: "رابط الفيديو",
  selected_video: "الفيديو المختار",
  add_video: "إضافة فيديو",
  edit_video: "تحرير الفيديو",
  linl_video: "رابط النقل",
  upload_video: "رفع الفيديو",
  rule_link:
    "يجب أن يكون نطاق الموقع بصيغة https://terminalads.com أو terminalads.com.",
  fax_hint: "يرجى إدخال فاكس الشركة.",
  fax_label: "فاكس الشركة",
  website_hint: "يرجى إدخال موقع الشركة.",
  website_label: "موقع الشركة",
  postal_code_hint: "يرجى إدخال الرمز البريدي.",
  postal_code_label: "الرمز البريدي",
  add_more_info: "أضف المزيد من المعلومات المطلوبة:",
  address_hint: "يرجى إدخال عنوانك.",
  address_label: "العنوان",
  edit_location: "تحرير",
  add_location: "إضافة",
  delete_location: "حذف الموقع",
  location_label: "الموقع",
  about_company_label: "حول الشركة",
  select_address_on_map: "اختيار العنوان على الخريطة",
  search_address: "البحث عن العنوان:",
  rule_link:
    "يجب أن يكون نطاق الموقع بصيغة https://terminalads.com أو terminalads.com.",
  link_label: "عنوان الرابط",
  label_label: "العنوان",
  field_value_label: "قيمة الحقل",
  add_new_field: "إضافة حقل جديد",
  tehran_address: "طهران، شارع شريعتي، بعد جسر سيد خندان، زقاق خندان، رقم 6",
  welcome_message_hint:
    "عند تفعيل هذا، سيتم إرسال رسالة ترحيب عند انضمام العملاء إلى ناديكم.",
  change_pattern_campaign: "تغيير النمط/الحملة",
  selected_message: "الرسالة المحددة:",
  required_inputs: "المدخلات الإلزامية:",
  selected_campaign_or_pattern: "الحملة/النمط المحدد:",
  campaign: "حملة",
  pattern: "نمط",
  id: "المعرف",
  auto_csv_download_label: "حفظ تلقائي",
  auto_csv_download_hint:
    "بعد فتح البطاقة، سيتم تحميل معلوماتك تلقائيًا على هاتف العميل.",
  show_cclub_onload_label: "اقتراح العضوية",
  show_cclub_onload_hint: "سيتم عرض نافذة للانضمام إلى نادي العملاء.",
  forced_submission_hint: "مع عرض نموذج العضوية، يجب على المستخدم تسجيل رقمه.",
  forced_submission_forced: "عضوية إلزامية",
  forced_submission_optional: "عضوية اختيارية",
  has_manifest_icons_label: "تخصيص تطبيق الويب",
  has_assistant_label: "تسمية المساعد",
  select_assistant: "اختر المساعد",
  assistant_ai: "مساعد الذكاء الاصطناعي",
  has_manifest_icons_hint:
    "الشعار والصورة ستظهر عند تثبيت تطبيق الويب على الجوال أو الحاسوب.",
  logo_144px: "شعار 144 بكسل",
  logo_48px: "شعار 48 بكسل",
  photo_wide: "صورة عريضة",
  photo: "صورة",
  iranian_social_networks: "شبكات التواصل الإيرانية",
  foreign_social_networks: "شبكات التواصل الأجنبية",
  advertising_sites: "مواقع إعلانية",
  other_links: "روابط أخرى",
  custom_text: "نص مخصص",
  custom_text_placeholder: "أدخل نصك المخصص.",
  aparat: "أبارات",
  aparat_hint: "أدخل اسم قناتك على أبارات",
  eitaa: "إيتا",
  eitaa_hint: "أدخل اسم المستخدم الخاص بك",
  soroush: "سروش",
  soroush_hint: "أدخل اسم المستخدم الخاص بك",
  bale: "بالي",
  bale_hint: "أدخل اسم المستخدم الخاص بك",
  rubika: "روبيكا",
  rubika_hint: "أدخل رابط القناة/المجموعة",
  gap: "غاب",
  gap_hint: "أدخل اسم المستخدم الخاص بك",
  linkedin: "صفحة لينكدإن الشخصية",
  linkedin_hint: "أدخل اسم المستخدم الخاص بك",
  linkedin_company: "صفحة الشركة على لينكدإن",
  linkedin_company_hint: "أدخل اسم صفحة الشركة الخاصة بك",
  pinterest: "بينترست",
  pinterest_hint: "أدخل اسم المستخدم الخاص بك",
  dribbble: "دريبل",
  dribbble_hint: "أدخل اسم المستخدم الخاص بك",
  facebook: "فيسبوك",
  facebook_hint: "أدخل اسم المستخدم الخاص بك",
  github: "غيت هاب",
  github_hint: "أدخل اسم المستخدم الخاص بك",
  threads: "ثريدز",
  threads_hint: "أدخل اسم المستخدم الخاص بك",
  tiktok: "تيك توك",
  tiktok_hint: "أدخل اسم المستخدم الخاص بك",
  twitter: "تويتر",
  twitter_hint: "أدخل اسم المستخدم الخاص بك",
  skype: "سكايب",
  skype_hint: "أدخل اسم المستخدم الخاص بك",
  youtube: "يوتيوب",
  youtube_hint: "أدخل اسم المستخدم بدون @",
  wechat: "وي تشات",
  wechat_hint: "أدخل اسم المستخدم الخاص بك",
  viber: "فايبر",
  viber_hint: "أدخل اسم المستخدم الخاص بك",
  divar: "ديوار",
  divar_hint: "أدخل رابط الإعلان/اللوحة/المتجر",
  sheypoor: "شيبور",
  sheypoor_hint: "أدخل رابط الإعلان/اللوحة/المتجر",
  social_network: "شبكة اجتماعية",
  photo_logo_tab: "صورة/شعار",
  gallery_image_tab: "معرض الصور",
  template_image: "صورة القالب",
  background_image: "صورة الخلفية",
  upload_logo: "رفع الشعار",
  welcome_image_upload: "رفع صورة/شعار الترحيب",
  welcome_photo: "صورة الترحيب",
  loading_animation: "رسوم تحميل متحركة",
  preview_welcome_page: "معاينة صفحة الترحيب",
  default_template_image: "صورة خلفية القالب",
  default_background_image: "صورة الخلفية",
  default_logo: "الشعار",
  default_welcome: "الترحيب",
  default_gallery: "المعرض",
  animation_scale: "التكبير من المركز",
  animation_slide_x: "الدخول من اليسار",
  animation_slide_y: "الدخول من الأعلى",
  animation_fade: "التلاشي",
  image_size_error: "الحد الأقصى لحجم كل صورة خلفية هو 2 ميغابايت.",
  logo_size_error: "الحد الأقصى لحجم كل شعار هو 2 ميغابايت.",
  categories: {
    bankcard: 'بطاقة مصرفية', 
    bale: "بله",
    robika: "روبيكا",
    eitaa: "إيتا",
    text: "نص",
    multi_card: "بطاقة متعددة",
    product_introduction_pro: "تقديم منتج برو",
    "gift": "هدية",
    electronic_business_card_pro: "بطاقة الأعمال الإلكترونية برو",
    link_pro:"لينك برو",
    generated_images: "الصور المُنشأة",
    electronic_business_card: "بطاقة أعمال إلكترونية",
    social_media: "وسائل التواصل الاجتماعي",
    photo_gallery: "معرض الصور",
    video_gallery: "معرض الفيديو",
    link: "رابط",
    audio_gallery: "معرض الصوت",
    audio_gallery_pro: "معرض الصوت (برو)",
    feedback: "ردود الفعل",
    consultation_form: "نموذج طلب استشارة",
    application: "تقديم التطبيق",
    pdf_gallery: "معرض PDF",
    schedule_table: "جدول الجدولة",
    personal_company_website: "موقع شخصي/شركة",
    online_store: "متجر عبر الإنترنت",
    online_menu: "قائمة عبر الإنترنت",
    appointment_booking: "حجز موعد",
    commercial_admin_website: "موقع مجمع تجاري/إداري",
    online_insurance_sales: "بيع تأمين عبر الإنترنت",
    discount_code: "رمز الخصم",
    product_introduction: "تقديم المنتج",
    product_label: "تسمية المنتج",
    gold_label: "تسمية الذهب",
    franchise: "فرانشايز (صفحة أعمال)",
    marketplace: "ماركت بليس (صفحة أعمال)",
    recruitment_form: "نموذج توظيف",
    organizational_form: "نموذج تنظيمي",
    employee_card: "بطاقة موظف",
    book_magazine: "كتاب/مجلة",
    catalog_brochure: "كتالوج/كتيب",
    catalog: "كتالوج",
    faq: "الأسئلة الشائعة",
    feedback_survey: "ردود فعل / استطلاع رأي",
    consultation_request: "طلب استشارة",
    customer_club: "نادي العملاء",
    invitation_card: "بطاقة دعوة",
    countdown: "عد تنازلي",
    tombstone: "شاهد قبر",
  },
  support_day60: "ضمانة استرداد الأموال لمدة 60 يومًا",
  "enter_visit_card_pro_info": "أدخل اسم البطاقة الشخصية برو",

  ROUTE: {
    TITLES: {
    QR_NAME_EDIT_TEXT: "تعديل نص رمز QR",
    SERVER_DOWN: "جاري التحديث",
    CREATE_MEMORIES_MODEL: "إنشاء نموذج إطار الذكريات",
    CREATE_CARD_VISIT_PRO_MODEL: "إنشاء نموذج بطاقة العمل الاحترافية",
    CREATE_PRODUCT_PRO_MODEL: "إنشاء نموذج تعريف المنتج الاحترافي",
    CREATE_PRODUCT_LABEL_MODEL: "إنشاء نموذج ملصق المنتج",
    CREATE_PHOTO_GALLERY_MODEL: "إنشاء نموذج معرض الصور",
    CREATE_PDF_GALLERY_MODEL: "إنشاء نموذج معرض ملفات PDF",
    CREATE_SOCIAL_MEDIA_MODEL: "إنشاء نموذج وسائل التواصل الاجتماعي",
    EDIT_CARD_VISIT_PRO_MODEL: "تعديل نموذج بطاقة العمل الاحترافية",
    EDIT_PRODUCT_PRO_MODEL: "تعديل نموذج تعريف المنتج الاحترافي",
    EDIT_PRODUCT_LABEL_MODEL: "تعديل نموذج ملصق المنتج",
    EDIT_PHOTO_GALLERY_MODEL: "تعديل نموذج معرض الصور",
    EDIT_PDF_GALLERY_MODEL: "تعديل نموذج معرض ملفات PDF",
    EDIT_SOCIAL_MEDIA_MODEL: "تعديل نموذج وسائل التواصل الاجتماعي",
    BOOK: "كتاب",
    NFC_LIST: "قائمة بطاقات NFC",
    API_KEY_MANAGER: "إنشاء مفتاح API",
    PRE_PURCHASE: "الشراء المسبق",
    PRE_PURCHASE_MODEL: "نموذج جاهز",
       "QR_NAME_EDIT_GIFT": "تعديل رمز QR للهدية",
      "QR_GIFT": "رمز QR للهدية",
      "QR_NAME_EDIT_PRO": "تعديل رمز الاستجابة السريعة للرابط برو",
      "QR_LINK_PRO": "كيوار لينك برو",
      DIGI: "مراقبة أسعار ديجي كالا",
      QR_PDF: "معرض ملفات PDF",
      QR_NAME_EDIT_PDF: "تعديل معرض ملفات PDF",
      QR_MULTICART: "كرت متعدد QR",
      QR_MULTICART_EDIT: "تعديل الكرت المتعدد QR",
      QR_NAME_PRODUCTPRO: "تعديل عرض المنتج الاحترافي",
      QR_PRODUCTPRO: "عرض المنتج الاحترافي",
      QR_NAME_EDIT_CATALOG: "تعديل الكتالوج",
      QR_LUCK_WHEEL_Edit: "تحرير عجلة الحظ",
      QR_LUCK_WHEEL: "إنشاء رمز QR لعجلة الحظ",
      DASHBOARD: "لوحة التحكم",
      ADMIN_QR_DOMAINS: "مراقبة النطاقات",
      ADMIN_TOGETHER_TOKEN: "مراقبة الرموز",
      ADMIN_QR_SMS: "إرسال الرسائل النصية",
      MENU_PROFILE_INFO: "معلومات المستخدم",
      MENU_PROFILE_SETTING: "إعدادات الملف الشخصي",
      MENU_PROFILE_ORDERS: "الطلبات",
      MENU_PROFILE_ADDRESSES: "العناوين",
      QR_MONITORING: "مراقبة رمز الاستجابة السريعة",
      QR_LIST: "قائمة رموز الاستجابة السريعة الخاصة بي",
      QR_NAME_LIST: "إدارة المشاركة",
      QR_GENERATE_MULTIPLE: "إنشاء رموز استجابة سريعة جماعية",
      QR_CARD_VISIT: "إنشاء بطاقة زيارة",
      HELP_INFO: "اختبار الزر",
      QR_MENU: "قائمة المتجر",
      QR_APPOINTMENT: "حجز موعد",
      QR_INSURANCE: "إنشاء تأمين عبر الإنترنت",
      QR_BPAGE: "إنشاء صفحة عمل",
      QR_CPAGE: "إنشاء موقع مجمع تجاري/إداري",
      QR_BSHOP: "متجر إلكتروني",
      QR_NAME_EDIT_BSHOP: "تعديل المتجر الإلكتروني",
      QR_LINK_EDIT: "تعديل الرابط",
      QR_NAME_DESIGN: "تعديل التصميم",
      QR_NAME_SETTING: "تعديل الإعدادات",
      QR_NAME_EDIT: "تعديل بطاقة الزيارة",
      QR_NAME_EDIT_BPAGE: "تعديل صفحة العمل",
      QR_EDIT_CPAGE: "تعديل موقع المجمع التجاري/الإداري",
      QR_NAME_INSURANCE: "تعديل التأمين عبر الإنترنت",
      QR_NAME_EDIT_MENU: "تعديل القائمة",
      QR_NAME_EDIT_APPLICATION: "تقديم التطبيق",
      QR_NAME_EDIT_APPOINTMENT: "تعديل حجز الموعد",
      QR_NAME_EDIT_PHOTO: "تعديل معرض الصور",
      QR_NAME_EDIT_VIDEO: "تعديل معرض الفيديو",
      QR_NAME_EDIT_VOICE: "تعديل معرض الصوت",
      QR_NAME_EDIT_FEEDBACK: "تعديل معرض التعليقات",
      QR_NAME_CONSULTATION_QR_EDIT: "تعديل نموذج الطلب",
      QR_NAME_EDIT_VOICE_PRO: "تعديل معرض الصوت (المحترف)",
      QR_NAME_EDIT_SOCIAL: "تعديل الشبكات الاجتماعية",
      QR_NAME_STATISTICS: "إحصائيات رمز الاستجابة السريعة",
      QR_CATE: "اختيار الفئة",
      QR_SHARE: "مشاركة",
      QR_BUSINESS_SHOP: "أعمال/متجر",
      QR_CO_ORGAN: "شركة/منظمة",
      QR_CONTACT: "الاتصال بالعميل",
      QR_NOTICES: "الإشعارات",
      QR_OTHERS: "متنوع",
      QR_STATICS: "رمز استجابة سريعة ثابت",
      QR_DYNAMICS: "رمز استجابة سريعة ديناميكي",
      QR_D_BUSINESS: "رمز استجابة سريعة ديناميكي تجاري",
      QR_D_ORGANS: "رمز استجابة سريعة ديناميكي تنظيمي",
      QR_D_GOVERNMENT: "رمز استجابة سريعة ديناميكي حكومي",
      QR_VIDEO: "معرض الفيديو",
      QR_APPLICATION: "تقديم التطبيق",
      QR_VOICE: "معرض الصوت",
      QR_VOICE_PRO: "معرض الصوت (المحترف)",
      QR_CONSULTATION_QR: "نموذج الطلب",
      QR_FEEDBACK: "معرض التعليقات",
      QR_PHOTO: "معرض الصور",
      QR_CATALOG: "كتالوج / بروشور",
      QR_LOCATION: "إنشاء رمز استجابة سريعة للموقع",
      QR_SOCIAL_MEDIA: "إنشاء رمز استجابة سريعة للشبكات الاجتماعية",
      QR_LINK: "إنشاء رابط",
      QR_TEXT: "إنشاء نص",
      QR_MAIL: "إنشاء بريد إلكتروني",
      QR_CALL: "اتصال",
      QR_SMS: "رسالة نصية",
      QR_WHATSAPP: "واتساب",
      QR_SITE: "موقع إلكتروني",
      QR_INSTAGRAM: "إنستغرام",
      QR_SKYPE: "سكايب",
      QR_WIFI: "واي فاي",
      QR_BUSINESS: "صفحة عمل",
      QR_DISCOUNT: "صفحة الخصم",
      QR_PRODUCT_SHOP: "تقديم المنتج",
      QR_PRODUCT_LABEL: "تسمية المنتج",
      QR_GOLD_LABEL: "تسمية الذهب",
      QR_PRODUCT_TEMPLATE: "المنتجات",
      ADMIN_CATEGORY: "الفئات",
      QR_NFC_ORDERS: "بطاقات NFC في انتظار التأكيد",
      QR_NAME_PRODUCT: "تعديل تقديم المنتج",
      QR_NAME_LABELPRODUCT: "تعديل تسمية المنتج",
      QR_NAME_GOLDPRODUCT: "تعديل تسمية الذهب",
      QR_COINS: "العملات المشفرة",
      QR_SHOP: "إدارة المتجر",
      QR_TWITTER: "تويتر",
      UPLOAD_CENTER: "مركز الرفع",
      PRICING: "تعريفات رموز الاستجابة السريعة",
      QR_CREATE_MODELS: "إنشاء نموذج بطاقة زيارة",
      QR_CREATE_BUSINESS_MODELS: "إنشاء نموذج صفحة عمل",
      QR_CREATE_PRODUCT_MODEL: "إنشاء نموذج بطاقة منتج",
      QR_CREATE_MENU_MODELS: "إنشاء نموذج قائمة متجر",
      QR_CREATE_SHOP_MODEL: "إنشاء نموذج متجر إلكتروني",
      MODELS_LIST: "أنواع نماذج رموز الاستجابة السريعة",
      MODELS_LIST_EDIT: "تعديل النموذج",
      MODELS_LIST_MENU_EDIT: "تعديل نموذج القائمة",
      MODELS_LIST_BMODEL_EDIT: "تعديل نموذج المتجر الإلكتروني",
      NFC: "بطاقات NFC",
      SUBMIT_FORM: "تسجيل المدون",
      REQUEST_LIST: "قائمة المدونين",
      PURE_DATA: "قائمة بطاقات الزيارة غير المُنشأة",
      AUTO_CREATE: "إنشاء تلقائي لرمز الاستجابة السريعة",
      QR_CREATE: "إنشاء رمز استجابة سريعة",
      HISTORY_REMINDER: "مراقبة التذكير",
      BOOK: "مراقبة التذكير"
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "طرق الدفع",
      ORDER_NOTIFICATIONS: "إشعارات الطلبات",
      DISCOUNT_CODE: "رمز الخصم",
      CART: "سلة التسوق",
      TABLE_MANAGEMENT: "إدارة الطاولات",
    },
    ERRORS: {
      INVALID_INPUT: "يرجى إدخال القيم بشكل صحيح!",
      CART_SETTINGS_FAILED: "فشلت إعدادات سلة التسوق!",
    },
  },
  popup: {
    prepared_stores_title: "عينات من المتاجر الإلكترونية الجاهزة",
  },
  buttons: {
    reset_defaults: "إعادة تعيين البيانات الافتراضية",
    download_qr: "تحميل رمز الاستجابة السريعة",
    cleardefaults: "حذف المعلومات الافتراضية",
    select_prepared_store: "اختيار متجر إلكتروني جاهز",
  },
  stepper: {
    create_qr: "إنشاء رمز استجابة سريعة",
    products_info: "المنتجات والمعلومات",
    content_settings: "إعدادات المحتوى",
    sales_settings: "إعدادات المبيعات",
  },
  fields: {
    online_store_name: "اسم المتجر الإلكتروني",
    qr_address: "عنوان رمز الاستجابة السريعة",
    qr_address_hint: "أدخل عنوان رمز الاستجابة السريعة الخاص بك",
    online_sale: "البيع عبر الإنترنت",
  },
  login_settings: "إعدادات تسجيل الدخول",
  shop_logo_and_images: "شعار وصور المتجر",
  login_page_info: "معلومات صفحة تسجيل الدخول",
  upload_banner: "رفع اللافتة",
  create_product: "إنشاء منتج",
  special_sale: "بيع خاص",
  ended: "منتهي",
  blog: "مدونة",
  services: "خدمات",
  pdf_gallery: "معرض PDF",
  create_section: "إنشاء قسم",
  achievements: "الإنجازات المحققة",
  team_members: "أعضاء الفريق",
  working_hours: "ساعات العمل",
  saturday: "السبت",
  sunday: "الأحد",
  monday: "الإثنين",
  tuesday: "الثلاثاء",
  wednesday: "الأربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  we_will_be_different: "سنكون مختلفين...",
  striving_for_excellence: "نسعى دائمًا لنكون الأفضل >>> من أجلك",
  online_store_ready_15_minutes: "متجرك الإلكتروني جاهز في 15 دقيقة!",
  sales_management: "إدارة المبيعات",
  dear_customer_online_stores:
    "عزيزي العميل، يمكنك التسوق من متاجرنا الإلكترونية الأخرى أيضًا:",
  divar_site: "موقع ديوار",
  digikala_site: "موقع ديجي كالا",
  basalam_site: "موقع باسلام",
  torob_site: "موقع ترب",
  emalls_site: "موقع إيمالز",
  copyright_qrland: "جميع الحقوق محفوظة لـ QR Land.",
  tehran_address: "طهران، شارع شريعتي، بعد جسر سيد خندان، زقاق خندان، رقم 6",
  our_achievements: "إنجازات مجموعتنا",
  customer_satisfaction: "رضا العملاء",
  lowest_returns: "أقل المرتجعات",
  loyal_customer: "عميل مخلص",
  shipped_orders: "طلبات مشحونة",
  visit_our_videos: "تفضل بزيارة فيديوهات مجموعتنا.",
  bringing_the_best: "قدمنا لك الأفضل...",
  feedback_important: "تعليقاتك مهمة بالنسبة لنا",
  guide_us_with_feedback:
    "يرجى الإجابة على الأسئلة أدناه لمساعدتنا في تقديم خدمات أفضل.",
  satisfied_with_quality: "هل أنت راضٍ عن جودة المنتجات؟",
  evaluate_packaging_quality: "كيف تقيّم جودة التغليف؟",
  satisfied_with_variety: "هل أنت راضٍ عن تنوع المنتجات؟",
  benefited_from_discounts: "هل استفدت من خصومات هذا المتجر؟",
  post_1: "منشور 1",
  fast_order_delivery: "تسليم الطلب بسرعة",
  post_2: "منشور 2",
  post_3: "منشور 3",
  product_authenticity_guarantee: "ضمان أصالة المنتج",
  comfortable_purchase: "تسوق مريح",
  how_to_place_order: "كيف يمكنني تسجيل طلبي؟",
  add_to_cart: "أضف المنتجات المطلوبة إلى سلة التسوق.",
  how_to_register: "كيف يمكنني التسجيل في الموقع؟",
  click_login_and_enter_code:
    "انقر على زر 'تسجيل الدخول'، ثم أدخل رقم هاتفك وكود الرسالة النصية.",
  delivery_time: "كم من الوقت يستغرق وصول طلبي بعد التسجيل؟",
  fastest_delivery: "يتم شحن طلبك في أسرع وقت ممكن.",
  shipping_cost: "كم تبلغ تكلفة شحن الطلب؟",
  shipping_cost_order: "تكلفة شحن الطلب",
  variable_shipping_cost: "تختلف تكلفة الشحن حسب عنوانك.",
  change_or_cancel_order: "هل يمكنني تغيير أو إلغاء الطلب بعد التسجيل؟",
  no_change_or_cancel: "لا، لا يمكن التغيير أو الإلغاء.",
  mrs_Safdarian: "السيدة صفدريان",
  invalid_address: "العنوان المدخل غير صحيح!",
  shop_page_created_success: "تم إنشاء صفحة المتجر بنج7نجاح.",
  qr_creation_failed: "فشل إنشاء رمز الاستجابة السريعة!",
  server_error: "خطأ في الخادم!",
  qr_card_updated_success: "تم تعديل بطاقة الزيارة بنجاح.",
  qr_save_edit_failed: "خطأ في حفظ/تعديل رمز الاستجابة السريعة",
  your_feedback: "تعليقك",
  digital_marketing_strategy:
    "ضع شركتك على الطريق الصحيح مع استراتيجي التسويق الرقمي لدينا",
  wait_for_default_products:
    "يرجى الصبر حتى يتم تحميل المنتجات الافتراضية بالكامل في موقعك.",
  template_categories_saved: "تم حفظ فئات النموذج بنجاح.",
  template_products_saved: "تم حفظ منتجات النموذج بنجاح.",
  template_products_save_failed: "خطأ في حفظ منتجات النموذج!",
  template_categories_save_failed: "خطأ في حفظ فئات النموذج!",
  login_page_text: "نص صفحة تسجيل الدخول",
  persian_error: "يجب أن يكون النص بالفارسية",
  number_error: "البيانات المدخلة يجب ألا تكون غير أرقام أو فارغة",
  english_error: "يجب ألا يكون النص غير إنجليزي أو فارغ",
  mixPerEng_error: "يجب ألا يكون النص غير إنجليزي أو غير فارسي أو فارغ",
  email_error: "تنسيق البريد الإلكتروني غير صحيح",
  mobile_error: "تنسيق الرقم غير صحيح",
  meliCode_error: "تنسيق الرمز الوطني غير صحيح",
  site_error: "تنسيق الموقع غير صحيح",
  min_length_error: "لا يمكن أن تكون القيمة المدخلة أقل من {{min}}",
  max_length_error: "لا يمكن أن تكون القيمة المدخلة أكثر من {{max}}",
  form_submitted_message: "تم إرسال النموذج بنجاح",
  required_fields_error: "لم يتم إدخال القيم الإلزامية",
  headphone_title: "سماعات الرأس",
  buy_button: "شراء",
  day: "يوم",
  hour: "ساعة",
  minute: "دقيقة",
  second: "ثانية",
  required_field_error: "{{fieldName}} إلزامي",
  submit_request_button: "تسجيل الطلب",
  request_submitted_success: "تم تسجيل طلبك بنجاح",
  feedback_submitted_success: "تم تسجيل تعليقك بنجاح",
  description_required_label: "الوصف (إلزامي)",
  description_optional_label: "الوصف (اختياري)",
  description_hint: "يرجى إدخال الوصف المطلوب في هذا الحقل (3 أحرف على الأقل)",
  footer: {
    position: "الجانب",
    contactUs: "اتصل بنا",
    aboutUs: "من نحن",
    firstShift: "الوردية الأولى",
    secondShift: "الوردية الثانية",
    startTime: "وقت البداية",
    endTime: "وقت الانتهاء",
    features: "الميزات",
    partners: "الشركاء",
    affiliates: "البرامج التابعة",
    panels: "اللوحات",
    supportTicket: "تذكرة الدعم",
    inPersonServices: "خدمات حضورية",
    liveChat: "دردشة مباشرة",
    faq: "الأسئلة الشائعة",
    add_secondshift: "إضافة وردية ثانية",
    firstDate: "تاريخ البداية",
    endDate: "تاريخ الانتهاء",
  },
  qr_management: "إدارة رموز الاستجابة السريعة",
  restore_default_questions: "استعادة الأسئلة الافتراضية",
  delete_all: "حذف الكل",
  edit_question: "تعديل السؤال",
  move_up: "للأعلى",
  move_down: "للأسفل",
  delete: "حذف",
  selected_question: "السؤال المختار",
  question: "سؤال",
  answer_type: "نوع الإجابة",
  excellent: "ممتاز",
  good: "جيد",
  very_poor: "ضعيف جدًا",
  response_optionality: "اختياري / إلزامي الإجابة",
  required: "إلزامي",
  optional: "اختياري",
  add_new_question: "إضافة سؤال جديد",
  satisfied_with_quality: "هل أنت راضٍ عن جودة المنتجات؟",
  evaluate_packaging_quality: "كيف تقيّم جودة التغليف؟",
  satisfied_with_variety: "هل أنت راضٍ عن تنوع المنتجات؟",
  benefited_from_discounts: "هل استفدت من خصومات هذا المتجر؟",
  suggestions_for_improvement: "ما اقتراحك لتحسين تجربة التسوق في هذا المتجر؟",
  confirm_delete_question: "حذف السؤال المختار؟",
  question_deleted_success: "تم حذف السؤال بنجاح.",
  question_delete_failed: "خطأ في حذف السؤال!",
  confirm_delete_all_questions: "هل أنت متأكد من حذف جميع الأسئلة؟",
  questions_deleted_success: "تم حذف الأسئلة بنجاح.",
  questions_delete_failed: "خطأ في حذف الأسئلة!",
  invalid_input: "يرجى إدخال القيم بشكل صحيح!",
  operation_failed: "فشلت العملية!",
  question_number: "سؤال {number}؟",
  card_subtitle:
    "أدخل قصة الصورة المطلوبة، وسيقوم الذكاء الاصطناعي بإنشائها لك.",
  upgrade_label: "إرفاق",
  free: " - مجانًا",
  language_select: "اختيار اللغة لكتابة نص الطلب",
  image_size: "حجم الصورة",
  prompt_label: "نص الطلب",
  prompt_placeholder: "صف الصورة المطلوبة...",
  generate_image: "إنشاء صورة",
  regenerate_image: "إنشاء صورة جديدة",
  save_image: "حفظ الصورة",
  save_image_subtitle: "سيتم حفظ الصورة المعروضة أعلاه فقط.",
  size_items: {
    "16:9": "16:9 (أفقي)",
    "9:16": "9:16 (عمودي)",
    "1:1": "1:1 (مربع)",
  },
  lang_items: {
    fa: "Fa | الفارسية",
    en: "En | الإنجليزية",
    ar: "Ar | العربية",
  },
  rules: {
    empty: "يجب إدخال 3 أحرف على الأقل!",
    spell_checker: "يجب أن يكون النص باللغة {language}!",
  },
  ERRORS: {
    VpnDetectedTitle: "يرجى إيقاف VPN",
    VpnDetectedSubtitle:
      "هذا يساعد النظام على العمل بشكل أفضل ويمنحك تجربة أفضل.",
  },
  errors: {
    VpnDetectedTitle: "يرجى إيقاف VPN",
    VpnDetectedSubtitle:
      "هذا يساعد النظام على العمل بشكل أفضل ويمنحك تجربة أفضل.",
    invalid_size: "يرجى إدخال العرض والارتفاع بشكل صحيح!",
    image_generation_error: "خطأ في إنشاء الصورة",
    image_upload_error: "خطأ في رفع الصورة!",
    service_unavailable:
      "لا يمكن استخدام هذه الخدمة - حدث خطأ أثناء تحميل البيانات من الخادم",
    qr_address_taken: "عنوان QR هذا مستخدم بالفعل",
  },
  add_working_time: "إضافة وقت العمل",
  selected_day: "اليوم المختار",
  range_name: "اسم الفترة الزمنية",
  add: "إضافة",
  first_shift: "الوردية الأولى",
  second_shift: "الوردية الثانية",
  start_time: "وقت البداية",
  end_time: "وقت الانتهاء",
  date_range: "الفترة الزمنية",
  all_week_days: "جميع أيام الأسبوع",
  saturday_to_wednesday: "السبت إلى الأربعاء",
  saturday_to_thursday: "السبت إلى الخميس",
  work_week: "جميع أيام الأسبوع (باستثناء أيام العطل)",
  feedbacks: "التعليقات",
  failed_retrieve_feedback: "فشل استرجاع التعليقات!",
  province: "المحافظة",
  search_city_placeholder: "ابحث عن اسم المدينة المطلوب.",
  search_city_label: "بحث المدينة",
  welcome: "مرحبًا بك في تطبيقنا",
  description: "هذا تطبيق متعدد اللغات.",
  soon: "قريبًا",
  beta_version: "نسخة تجريبية",
  defaults_cleared_success: "تم حذف البيانات الافتراضية بنجاح",
  defaults_reset_success: "تم إعادة تعيين البيانات الافتراضية بنجاح",
  select_navigator_after_location_click:
    "بعد النقر على الموقع، اختر الملاح الخاص بك",
  no_address_selected: "لم يتم اختيار عنوان",
  no_location_selected: "لم يتم اختيار موقع",
  region: "المنطقة",
  api_unauthorized: "خطأ في التحقق من الهوية: مفتاح API غير صالح",
  location_not_found: "الموقع غير موجود",
  addCategory: "إضافة فئة جديدة",
  editCategory: "تعديل الفئة",
  deleteCategory: "حذف الفئة المختارة؟",
  addProduct: "إضافة منتج جديد",
  saveProducts: "اختيار المنتجات الافتراضية",
  addSubCategory: "إضافة فئة فرعية",
  product: "المنتج",
  categoryName: "اسم الفئة",
  subCategoryName: "اسم الفئة الفرعية",
  confirmDeleteProduct: "هل أنت متأكد من حذف المنتج من الفئة؟",
  successMessages: {
    categorySaved: "تم حفظ الفئات بنجاح.",
    productSaved: "تم حفظ المنتجات بنجاح.",
    productDeleted: "تم حذف المنتج بنجاح.",
  },
  errorMessages: {
    saveCategoryFailed: "خطأ في حفظ الفئات!",
    saveProductFailed: "خطأ في حفظ المنتجات!",
    deleteCategoryFailed: "خطأ في حذف الفئة!",
  },
  add_edit_categories: "تعديل/إضافة فئة",
  copy_category: "نسخ الفئة",
  product: "المنتج {point}",
  copy_product: "نسخ المنتج",
  add_edit_products: "إضافة/تعديل المنتجات",
  copy_category: "نسخ الفئة",
  edit_category: "تعديل الفئة",
  category_name: "اسم الفئة",
  edit_subcategory: "تعديل الفئة الفرعية",
  subcategory_name: "اسم الفئة الفرعية",
  add_new_category: "إضافة فئة جديدة",
  store_management: "إدارة المتجر",
  manage_products: "إدارة المنتجات",
  products_export: "تنزيل المنتجات",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "رفع ملف إكسل",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1": "اسحب ملف الإكسل الخاص بك وأفلته هنا أو",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "اختر",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "للرفع",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE": "يرجى رفع ملف إكسل فقط (.xlsx)",
  "GENERAL.SUBMIT": "إرسال",
  "GENERAL.CANCEL": "إلغاء",
  "GENERAL.SUCCESSFULLY_ADDED": "تم رفع المنتجات بنجاح",
  SUCCESSFULLY_DOWNLOADED: "تم تنزيل المنتجات بنجاح",
  "GENERAL.ERROR": "حدث خطأ",
  EditSubCategoty: "تعديل الفئة الفرعية",
  create: "إنشاء",
  save_changes: "حفظ التغييرات",
  buy_button_settings: "إعدادات زر الشراء",
  image: "صورة",
  color: "لون",
  title: "عنوان",
  price: "سعر",
  discount: "خصم",
  percent: "نسبة مئوية",
  amount: "مبلغ",
  brand: "علامة تجارية",
  inventory: "عدد المخزون",
  inventory_hint: "إذا كان الحقل فارغًا، فهذا يعني طلب غير محدود",
  order_limit: "الحد الأقصى للعدد في كل طلب",
  order_limit_hint: "إذا كان الحقل فارغًا، فهذا يعني بدون حد.",
  packing_price: "تكلفة التعبئة",
  packing_price_hint:
    "يتم تطبيقه إذا اختار العميل طلبًا للخارج (إرسال مع مندوب/زيارة حضورية).",
  description: "وصف",
  options: "خيارات",
  product_features: "ميزات المنتج",
  field_required: "الحقل مطلوب.",
  min_length: "الحد الأدنى لطول الحقل 3 أحرف.",
  product: "منتج",
  default_brand: "أبل",
  product_added_success: "تم إضافة المنتج بنجاح",
  product_added_error: "خطأ في إضافة المنتج",
  whole_categories: "(جميع الفئات)",
  add_select_category: "إضافة/اختيار فئة",
  select_default_category: "اختيار الفئة الافتراضية",
  deleted_product: "حذف المنتج",
  confirm_delete_prooduct: "هل أنت متأكد من حذف المنتج من الفئة؟",
  please_wait_store_product: "جاري حفظ المنتجات، يرجى الانتظار...",
  saved_product_success: "تم حفظ المنتجات بنجاح.",
  error_in_store: "خطأ في الحفظ",
  delete_category: "حذف الفئة",
  confirm_delete_category: "تم حذف الفئة بنجاح.",
  error_delete_category: "خطأ في حذف الفئة!",
  productOptionEditor: {
    tabs: {
      color: "لون",
      size: "حجم",
      count: "عدد",
      weight: "وزن",
      type: "نوع/جنس",
    },
    fields: {
      count: "عدد",
      max_order: "الحد الأقصى لعدد الطلب",
      price: "سعر",
      discount: "خصم",
      color: "لون",
      color_name: "اسم اللون",
      inventory: "عدد المخزون",
      size: "حجم",
      type: "نوع/جنس",
      weight: "وزن",
    },
    actions: {
      delete: "حذف",
      add_location: "إضافة خيار",
    },
  },
  extraSubProducts: {
    feature: "ميزة",
    name_label: "اسم",
    name_placeholder: "مثال: صلصة إضافية/خبز إضافي",
    price_label: "سعر",
    price_hint: "إذا كان الحقل فارغًا، فهذا يعني أن المنتج الفرعي مجاني.",
    price_placeholder: "مثال: ماء، نوع (مثل نوع الدجاج المطبوخ: صدر/فخذ)",
    add_subproduct: "إضافة منتج فرعي",
  },
  error_selected_category: "خطأ في اختيار الفئة!",
  suggestinput: {
    title: "اختيار إيموجي",
    aboutUs: "عنا",
    error: "خطأ",
    errorMessage: "يرجى شحن محفظتك وإعادة المحاولة.",
    generateText: "اقتراح الذكاء الاصطناعي",
    emoji: "إيموجي",
    errorMessage_400: "واجه إنشاء نص عنا مشكلة. يرجى المحاولة مرة أخرى.",
    errorMessage_403: "واجه إنشاء نص عنا مشكلة، يرجى شراء حزمة وإعادة المحاولة",
  },
  togetherai: {
    buy_package: "شراء حزمة",
    tax_notice: "سيتم إضافة 10% ضريبة على مبلغ الحزمة المشتراة!",
    package: "حزمة",
    rial: "﷼",
    buy_button: "أشتري!",
    discount_label: "كود الخصم",
    submit_discount: "تسجيل",
    success_message: "تم ترقية رمز الاستجابة السريعة الخاص بك بنجاح.",
    error_insufficient_funds: "يرجى التحقق من رصيد حسابك والمحاولة لاحقًا.",
    error_upgrade: "خطأ في تجديد رمز الاستجابة السريعة!",
    error_title: "خطأ",
    success_title: "نجاح",
  },
  category_not_found: "الفئة غير موجودة!",
  create_upload_category: "إنشاء فئة ورفع",
  add_subcategory: "إضافة فئة فرعية",
  error_upload_m_video: "خطأ في رفع الفيديو (قد يكون الوصول محدودًا).",
  info_show_video: "لعرض الفيديو أكثر، انقر على المزيد.",
  error_not_valid_guide_id: "معرف الدليل غير صالح!",
  error_give_guide_info: "خطأ في استلام معلومات التعليم!",
  info_success_saved: "تم الحفظ بنجاح",
  error_add_new_guide: "خطأ في إضافة دليل جديد",
  popup: {
    details: "تفاصيل",
    guide_images: "صور الدليل",
    guide_videos: "فيديوهات الدليل",
    faq: "الأسئلة الشائعة",
    no_title: "بدون عنوان",
    no_content: "لا يوجد محتوى للعرض",
    no_questions: "لا يوجد سؤال للعرض",
    video_error: "خطأ في تحميل الفيديو (قد يكون الوصول محدودًا)",
    no_answer: "لا يوجد إجابة",
    question_no_title: "سؤال بدون عنوان",
    default_title: "دليل",
  },
  productPicker: {
    select_default_product: "اختيار المنتج الافتراضي",
    search: "بحث",
    select_all_products: "اختيار جميع المنتجات",
    back: "رجوع",
    no_products_in_category: "لا يوجد منتج في هذه الفئة!",
    products_error: "خطأ في استلام المنتجات!",
    retry: "إعادة المحاولة",
    items_per_page: "عدد العرض",
    root_breadcrumb: "/",
  },
  end_date: "تاريخ الانتهاء",
  filters: {
    userType: {
      legal: "قانوني",
      individual: "فردي",
    },
    serviceType: {
      Payamakland: "پيامک‌لند",
      Coreland: "كُرلند",
      Qrland: "كيوآرلند",
      Robotland: "ربات‌لند",
      billboard: "بيلبورد",
      tablighNegar: "تبليغ‌نگار",
      unknown: "غير معروف",
    },
    qrType: {
      attendanceqr: "تسجيل الحضور والغياب",
       gift: "إطار الذكريات",
      instagram: "إنستغرام",
      visitCard: "بطاقة أعمال",
      Business: "شخصي / للشركات",
      Commericial: "موقع المجمع التجاري / الإداري",
      qrlink: "رابط QR",
      labelproduct: "ملصق المنتج",
      goldLabel: "ملصق الذهب",
      bShop: "المتجر",
      SocialMedia: "وسائل التواصل الاجتماعي",
      VideoGallery: "معرض الفيديوهات",
      PhotoGallery: "معرض الصور",
      voiceGallery: "المعرض الصوتي",
      consultationQr: "نموذج الطلب",
      application: "التطبيق",
      feedbackGallery: "آراء وملاحظات العملاء",
      voiceGalleryPro: "المعرض الصوتي الاحترافي",
      singleProduct: "التعريف بالمنتج",
      menu: "القائمة",
      appointment: "حجز موعد",
      insurance: "التأمين",
      text: "نص",
      luck_wheel: "عجلة الحظ",
      pdfgallery: "معرض ملفات PDF",
      productpro: "التعريف بالمنتج Pro",
      multicard: "بطاقات متعددة",
      catalog: "الكتالوج",
      visitCard_pro: "بطاقة أعمال Pro",
      clickyarseo: "ClickYar SEO QR",
    },
    expire: {
      day: "يوم",
      expired: "منتهي الصلاحية",
    },
    numericPersianNumber: {
      thousand: "ألف",
      million: "مليون",
    },
    dateString: {
      at: "في",
    },
    messages: {
      pleaseLogin: "يرجى تسجيل الدخول",
      invalidPhone: "رقم الهاتف غير صالح",
      copied: "تم النسخ",
    },
  },
  nextButton: "التالي",
  previousButton: "السابق",
  rowsPerPageText: "عدد في الصفحة",
  noDataText: "لا توجد بيانات للعرض",
  placeholderSearch: "ابحث..",
  set_qr: "رمز الاستجابة السريعة المسجل",
  numbers: "أرقام",
  enter_param_product: "أدخل مواصفات المنتجات بشكل صحيح!",
  instagram_hint: "يرجى إدخال إنستغرام الخاص بك",
  whatsapp_hint: "يرجى إدخال واتساب الخاص بك",
  telegram: "تلغرام",
  telegram_hint: "يرجى إدخال تلغرام الخاص بك",
  userpicker: {
    select_user: "اختيار مستخدم",
    choice_users: "اختيار مستخدمين",
    id: "معرف",
    phone_number: "رقم الهاتف",
    date_created: "تاريخ التسجيل",
    info_edit: "تعديل المعلومات",
    name_family: "الاسم واللقب",
    position: "المنصب والمرتبة",
    phone: "رقم الاتصال",
    discription: "وصف",
  },
  search_product: "بحث عن منتج",
  search_name_product: "ابحث عن اسم المنتج",
  search_name_product: "بحث اسم المنتج",
  search_product: "بحث المنتج",
  currency: "﷼",
  headers: {
    index: "ترتيب",
    gallery: "صورة",
    id: "معرف",
    name: "اسم",
    brand: "علامة تجارية",
    price: "مبلغ",
    discount_amount: "خصم",
  },
  search_categories: "بحث في الفئات",
  search_categories: "بحث ",
  delete_all: "حذف الكل",
  select_category: "اختيار فئة",
  currency1: "IRR", // عملة إيران (ريال)
  features: "ميزات",
  product_sp: {
    edit: "تعديل",
    back: "رجوع",
    save: "حفظ",
    add_product_to_special_category:
      "يرجى ملء الحقول أدناه لإضافة المنتج إلى فئة خاصة",
    inventory: "مخزون",
    discount: "خصم",
    max_per_customer: "العدد القابل للشراء لكل عميل",
    max_per_order: "العدد القابل للشراء في كل سلة",
    expires_at: "تاريخ الانتهاء",
    field_cannot_be_empty: "لا يمكن أن يكون الحقل فارغًا.",
    please_enter_correctly: "يرجى إدخال الحقول بشكل صحيح!",
    currency: "IRR", // عملة إيران (ريال)
  },
  selectproduct: "اختيار منتج",
  section: {
    edit_part: "تعديل القسم",
    title: "عنوان",
    position_text: "موقع النص",
    add_video: "إضافة فيديو",
    text: "نص",
    address_video: "عنوان الفيديو",
    position_left: "موقع يسار",
    position_right: "موقع يمين",
    tab_edit_button: "تعديل الزر",
    tab_content: "محتوى القسم",
  },
  name_shopping: "اسم المتجر",
  hint_shopping: "يرجى إدخال اسم متجرك.",
  title_discount: "عنوان الخصم",
  hint_discount: "أدخل عنوان خصمك.",
  hint_mount_discount: "احصل على 20٪ خصم للطلب التالي.",
  label_discount: "أدخل مقدار الخصم الخاص بك",
  give_discount: "الحصول على كود خصم",
  give_copon: "احصل على كوبون",
  enter_copon: "إدخال الكوبون",
  hint_phone: "يرجى إدخال رقم هاتفك.",
  label_phone: "رقم الهاتف",
  hint_condition_discount: "اشرح شروط الخصم الخاص بك..",
  label_discription_discount: "وصف الخصم",
  add_info_discount: "أضف المعلومات الإضافية المطلوبة:",
  enter_address_discount: "يرجى إدخال عنوانك.",
  address_discount: "عنوان",
  edit_feedback: "تعديل التعليق",
  select_type_replay: "اختيار نوع الرد",
  field_discription: "حقل الوصف",
  messages_discription: "بتفعيل هذا الخيار، سيتم عرض حقل للوصف للمستخدم",
  number_char: "يجب أن يكون عدد الأحرف بين 3 و50!",
  search: "بحث",
  no_videos_found: "لم يتم العثور على فيديو!",
  upload_video_prompt: "لإضافة ملف، استخدم قسم رفع الفيديو",
  delete_success: "تم الحذف بنجاح.",
  tabs: {
    qr_view: "عرض رمز الاستجابة السريعة",
    preview: "معاينة",
    ready_video: "فيديو جاهز",
    video_gallery: "معرض فيديو",
    link: "رابط",
    video_upload: "رفع فيديو",
  },
  consultation: {
    name: "اسم",
    surname: "لقب",
    phone: "رقم الهاتف المحمول",
    nationalId: "رمز وطني",
    nationalIdAuthenticate: "التحقق من الرمز الوطني",
    nationalIdCorrect: "التحقق من صحة الرمز الوطني",
    mail: "بريد إلكتروني",
    address: "عنوان",
    location: "موقع",
    custom: "قابل للتخصيص",
    customLabel: "عنوان",
    customOptions: "خيارات",
    optional: "اختياري",
    require: "إلزامي",
    description: "وصف",
  },
  add_section: "إضافة قسم",
  add_new_text_section: "تم دعوتك إلى أرض كيوآر لند الذكية الرقمية.",
  btn_title_section: "تسجيل مجاني",
  shop: {
    step_products_and_info: "المنتجات والمعلومات",
    online_store_name: "اسم المتجر عبر الإنترنت",
    qr_address: "عنوان رمز الاستجابة السريعة",
    qr_address_hint: "أدخل عنوان رمز الاستجابة السريعة الخاص بك",
    online_sale: "بيع عبر الإنترنت",
    step_content_settings: "إعدادات المحتوى",
    step_sale_settings: "إعدادات البيع",
    download_qr: "تنزيل رمز الاستجابة السريعة",
    login_settings: "إعدادات الدخول",
    store_logo_images: "شعار وصور المتجر",
    login_page_info: "معلومات صفحة الدخول",
    upload_banner: "رفع لافتة",
    user_info: "معلومات المستخدم",
    create_product: "إنشاء منتج",
    special_sale: "بيع خاص",
    add_social_media: "إضافة وسائل تواصل اجتماعي",
    blog: "مدونة",
    services: "خدمات",
    faq: "أسئلة شائعة",
    photo_gallery: "معرض صور",
    video_gallery: "معرض فيديو",
    pdf_gallery: "معرض PDF",
    feedback: "تعليق",
    countdown: "عد تنازلي",
    request_form: "نموذج طلب",
    create_section: "إنشاء قسم",
    achievements: "الإنجازات المحققة",
    team_members: "أعضاء الفريق",
    working_hours: "ساعات العمل",
    error_saving_content: "خطأ في حفظ إعدادات المحتوى!",
    success_edit_store: "تم تعديل صفحة المتجر بنجاح.",
    post_1: "منشور 1",
    logo: "شعار",
    background_image: "صورة الخلفية",
  },
  discount_obj: {
    quantity: "الكمية", 
    create_edit_code: "إنشاء/تعديل كود الخصم",
    coding_type_label: "إنشاء كـ",
    coding_type_single: "فردي",
    coding_type_group: "جماعي",
    status_label: "حالة",
    status_active: "نشط",
    status_deactivate: "غير نشط",
    discount_code: "كود الخصم",
    discount_type: "نوع الخصم",
    discount_type_percent: "نسبة مئوية",
    discount_type_fixed: "مبلغ ثابت",
    discount_value: "قيمة الخصم",
    discount_limit: "حد الخصم",
    no_limit: "بدون حد",
    tab_create_discount: "إنشاء كود خصم",
    tab_settings: "إعدادات",
    success_create: "تم إنشاء كود الخصم بنجاح",
    success_edit: "تم تعديل كود الخصم بنجاح",
    error_value_empty: "لا يمكن أن تكون قيمة الخصم فارغة!",
    error_start_time: "لم تختر وقت بدء الخطة!",
    error_end_time: "لم تختر وقت انتهاء الخطة!",
    error_same_time: "لا يمكن أن يكون وقت البدء والانتهاء متطابقًا",
  },
  personnel: {
    team_members: "أعضاء الفريق المختارين",
    add_team_member: "إضافة أعضاء الفريق",
    default_position: "المنصب والمرتبة",
    default_phone: "رقم الاتصال",
    default_full_name: "الاسم الكامل",
    default_description:
      "لوريم إيبسوم نص وهمي بإنتاج بساطة غير مفهومة من صناعة الطباعة وباستخدام مصممي الغرافيك",
  },
  discount_settings: {
    function_type: {
      title: "نوع أداء الخصم",
      all_shopping_cart: "إجمالي مبلغ سلة التسوق",
      special_products: "منتجات خاصة",
      special_categories: "فئة خاصة",
    },
    basket_condition: {
      title: "شروط سلة التسوق",
      no_conditions: "بدون قيود",
      minimum_shopping: "الحد الأدنى لمبلغ سلة التسوق",
      minimum_product: "الحد الأدنى لعدد المنتجات في سلة التسوق",
      maximum_shopping: "الحد الأقصى لمبلغ سلة التسوق",
      maximum_product: "الحد الأقصى لعدد المنتجات في سلة التسوق",
    },
    user_settings: {
      title: "إعدادات المستخدمين",
      all_user: "جميع المستخدمين",
      group: "مجموعة من المستخدمين",
      special: "مستخدمون خاصون",
    },
    limitation_use: {
      title: "حد الاستخدام",
      no_limitations: "بدون قيود",
      discount_code: "عدد استخدام كود الخصم",
      user: "عدد الاستخدام لكل مستخدم",
    },
    start_time: {
      title: "تاريخ بدء الخصم",
      no_time_selected: "لم يتم اختيار وقت للبدء",
    },
    end_time: {
      title: "تاريخ انتهاء الخصم",
      no_time_selected: "لم يتم اختيار وقت للانتهاء",
    },
  },
  counterService: {
    typeLabel: "نوع العرض",
    number: "رقم",
    percent: "نسبة مئوية",
    iconLabel: "أيقونة",
    counterLabel: "قيمة",
    linkLabel: "رابط",
    nameLabel: "عنوان",
    addButton: "إضافة نجاح محقّق",
    successful: {
      added: "تم إضافة العنصر بنجاح",
      removed: "تم حذف العنصر بنجاح",
      movedUp: "تم نقل العنصر إلى الأعلى بنجاح",
      movedDown: "تم نقل العنصر إلى الأسفل بنجاح",
    },
  },
  qrUsersList: {
    customersList: "قائمة العملاء",
    orders: "الطلبات",
    addresses: "العناوين",
    hasAssistantsMobile_hint: "اختر الجوال",
    invalidPhone: "رقم الجوال المدخل غير صالح",
    validation: {
      nameRequired: "إدخال الاسم مطلوب",
      nameMinLength: "يجب أن يتكون الاسم من حرفين على الأقل",
      familyRequired: "إدخال اسم العائلة مطلوب",
      familyMinLength: "يجب أن يتكون اسم العائلة من حرفين على الأقل",
    },
    addUser: "إضافة مستخدم",
    registerOnline: "تفعيل التسجيل عبر الإنترنت",
    usersColumns: {
      id: "معرف",
      name: "اسم",
      family: "لقب",
      mobile: "رقم الهاتف المحمول",
      subscriptionId: "رقم الاشتراك",
      ordersCount: "عدد الطلبات",
      lastLogin: "آخر دخول",
      status: "حالة",
      activeUser: "مستخدم نشط",
      none: "-",
      actions: "عمليات",
      buttons: {
        info: "معلومات العميل",
        sendSms: "إرسال رسالة نصية",
        history: "تاريخ",
        addresses: "عناوين",
        orders: "طلبات",
      },
    },
    orderColumns: {
      orderId: "رقم الطلب",
      customerName: "اسم العميل",
      mobile: "رقم الهاتف المحمول",
      paymentMethod: "طريقة الدفع",
      shippingMethod: "طريقة الاستلام",
      orderAmount: "مبلغ الطلب",
      orderTime: "وقت الطلب",
      status: "حالة",
      currency: "ريال",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "عنوان العنوان",
      name: "اسم",
      family: "لقب",
      mobile: "رقم الاتصال",
      address: "عنوان",
      zipCode: "رمز بريدي",
      number: "رقم",
      unit: "وحدة",
    },
    shippingType: {
      courier: "إرسال مع مندوب",
      reservation: "حجز طاولة",
      place: "استلام حضوري",
      none: "-",
    },
    paymentType: {
      online: "دفع عبر الإنترنت",
    },
    perPage: "عدد في الصفحة",
    search: "بحث",
    sortColumn: "ترتيب حسب",
    sortDirection: "اتجاه الترتيب",
    sortDirectionDesc: "تنازلي",
    sortDirectionAsc: "تصاعدي",
    noStatus: "لم يتم العثور على حالة",
    status: {
      all: "الكل",
      active: "نشط",
      inactive: "غير نشط",
    },
    fetchError: "خطأ في استلام معلومات المستخدمين",
  },
  listCardHeader: {
    clear_filters: "إزالة الفلاتر",
    group_qr_renewal: "تجديد جماعي لرمز الاستجابة السريعة",
    select_desired_duration: "اختر المدة الزمنية المطلوبة",
    total_count: "العدد الكلي",
    final_amount: "المبلغ النهائي",
    ten_percent_vat_will_be_added: "سيتم إضافة 10% ضريبة القيمة المضافة",
    pay_and_upgrade: "دفع وترقية",
    no_tariff_for_this_period: "لا يوجد تعرفة لهذه الفترة",
    one_month_renewal: "تجديد شهري",
    three_month_renewal: "تجديد ثلاثة أشهر",
    six_month_renewal: "تجديد ستة أشهر",
    one_year_renewal: "تجديد سنوي",
    selected: "مختار",
    view: "عرض",
    details: "تفاصيل",
    total_amount: "المبلغ الكلي",
    discount: "خصم",
    final_amount_with_discount: "المبلغ النهائي مع الخصم",
    add_qr: "إضافة رمز استجابة سريعة",
    select_all: "اختيار الكل",
    actions: "عمليات",
    filter: "فلتر",
    type_filter: "فلتر النوع",
    start_from: "ابدأ من",
    search: "بحث",
    id_search: "بحث في المعرف",
    filter_user: "فلتر المستخدم",
    sort: "ترتيب",
    send_sms: "إرسال رسالة نصية",
    selected_pattern: "النمط المختار:",
    send: "إرسال",
    newest: "الأحدث",
    oldest: "الأقدم",
    most_visited: "الأكثر زيارة",
    least_visited: "الأقل زيارة",
    pause: "إيقاف مؤقت",
    bulk_download: "تنزيل جماعي",
    activate: "تفعيل",
    deactivate: "إيقاف",
    error_loading_card: "خطأ في تحميل معلومات البطاقة!",
    error_fetching_prices: "خطأ في استلام الأسعار!",
    error_payment: "خطأ في الدفع!",
    sms_success: "تم تسجيل الإرسال بنجاح",
    generic_error: "حدث خطأ!",
  },
  headerTypeFilter: {
    qr_model: "نموذج رمز الاستجابة السريعة",
    all_qr_models: "جميع نماذج رمز الاستجابة السريعة",
  },
  menuOrderFactor: {
    order_invoice: "فاتورة الطلب",
    total: "الإجمالي",
    tax: "ضريبة",
    shipping_cost: "تكلفة الشحن",
    packing_cost: "تكلفة التعبئة",
    discount: "خصم",
    final_total: "الإجمالي",
    currency: "ريال",
    titles: {
      default_title: "طلب افتراضي",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "بحث في القائمة",
    search: "بحث",
    start_from: "ابدأ من",
  },
  headerStatusFilter: {
    all_qr_codes: "جميع رموز الاستجابة السريعة",
    active_qr_codes: "رموز الاستجابة السريعة النشطة",
    inactive_qr_codes: "رموز الاستجابة السريعة غير النشطة",
    expiring_qr_codes: "رموز الاستجابة السريعة القريبة من الانتهاء",
    expired_qr_codes: "رموز الاستجابة السريعة المنتهية",
  },
  qrOrdersList: {
    title: "قائمة الطلبات",
    orderColumns: {
      index: "ترتيب",
      id: "رقم الطلب",
      customerName: "اسم العميل",
      mobile: "رقم الهاتف المحمول",
      paymentType: "طريقة الدفع",
      shippingType: "طريقة الاستلام",
      price: "مبلغ الطلب",
      createdAt: "وقت الطلب",
      status: "حالة",
      actions: "عمليات",
    },
    productsColumns: {
      productId: "معرف المنتج",
      image: "صورة",
      productName: "اسم المنتج",
      unitPrice: "سعر الوحدة",
      quantity: "كمية",
      totalPrice: "سعر",
    },
    actions: {
      products: "قائمة الطلب",
      print: "طباعة الطلب",
      share: "مشاركة الطلب",
      status: "تغيير الحالة",
    },
    shippingType: {
      courier: "إرسال مع مندوب",
      reservation: "حجز طاولة",
      place: "استلام حضوري",
      post: "إرسال بالبريد",
      unknown: "-",
    },
    paymentType: {
      online: "دفع عبر الإنترنت",
      place: "دفع في الموقع",
      unknown: "-",
      card2card: "دفعة بطاقة إلى بطاقة",
    },
    status: {
      all: "الكل",
      pending: "في انتظار الدفع",
      accepted: {
        place: "دفع في الموقع",
        paid: "مدفوع",
      },
      delivered: "تم التسليم",
      rejected: "دفع غير ناجح",
    },
    factorTitle: "فاتورة الطلب",
    printFactor: "طباعة الفاتورة",
    fetchError: "خطأ في استلام المعلومات",
    statusChanged: "تم تغيير الحالة بنجاح",
    statusChangeError: "خطأ في تغيير الحالة",
    currency: "ريال",
    perPage: "عدد",
    search: "بحث",
    noStatus: "لا توجد حالة",
    loading: "جاري التحميل...",
    noShippingType: "لا توجد طريقة إرسال",
    noPaymentType: "لا توجد طريقة دفع",
    sortColumn: "عمود الترتيب",
    sortDirection: "اتجاه الترتيب",
    sortDirectionDesc: "تنازلي",
    sortDirectionAsc: "تصاعدي",
    selectNewStatus: "اختيار حالة جديدة",
    changeStatusTitle: "تغيير الحالة",
    linkCopied: "تم نسخ الرابط.",
  },
  qrUserTransfer: {
    title: "نقل الملكية",
    radioLabels: {
      userTransfer: "نقل إلى شخص آخر",
      givingAccess: "منح الوصول",
    },
    inputLabels: {
      phone: "هاتف الشخص",
    },
    hints: {
      addNumber: "لتحديد منح الوصول، اضغط Enter أو أيقونة +",
      addNumberStep2: "لإضافة رقم، اضغط Enter أو أيقونة +",
    },
    buttons: {
      transfer: "نقل",
      giveAccess: "منح الوصول",
      back: "رجوع",
      saveChanges: "حفظ التغييرات",
      cancel: "إلغاء",
        "add": "إضافة"

    },
    tooltips: {
      deleteAccess: "حذف الوصول",
    },
    subtitles: {
      accessList: "قائمة الأشخاص الذين لديهم وصول:",
      selectPermissions: "اختيار الصلاحيات:",
    },
    permissionList: {
      edit_name: "تعديل اسم الخدمة",
      edit_link: "تعديل الرابط",
      edit_info: "تعديل المعلومات",
      edit_design: "تعديل تصميم رمز الاستجابة السريعة",
      edit_settings: "تعديل إعدادات رمز الاستجابة السريعة",
      toggle_access: "وصول غير نشط/نشط",
      view_customers: "عرض قائمة العملاء",
      view_orders: "عرض قائمة الطلبات",
    },
    messages: {
      invalidPhone: "الرقم المدخل غير صالح",
      duplicatePhone: "لا يمكنك إدخال رقم مكرر",
      updateAccessSuccess: "تم تحديث الوصول بنجاح.",
      updateAccessError: "خطأ في تحديث الوصول: {message}",
      deleteAccessSuccess: "تم قطع الوصول بنجاح.",
      deleteAccessError: "خطأ في قطع الوصول: {message}",
      fetchAccessError: "خطأ في قراءة الوصول: {message}",
      transferSuccess: "تم نقل رمز الاستجابة السريعة بنجاح.",
      transferError: "خطأ في نقل رمز الاستجابة السريعة: {message}",
      giveAccessSuccess: "تم بنجاح.",
      giveAccessError: "خطأ في إعداد الوصول: {message}",
      confirmDeleteAccess: "هل أنت متأكد من قطع وصول الشخص المعني؟",
    },
  },
  form: {
    form_download: "النماذج المستلمة",
    form_add: "إضافة نموذج",
    formdownload: "نموذج مستلم",
    create_at: "تم إنشاؤه في :",
    shown: "عرض",
    nogiveform: "ليس لديك نموذج مستلم",
    back: "رجوع",
    invalid_date: "تاريخ غير صالح",
    select_date: "اختيار تاريخ",
    select: "اختيار",
    clear: "إلغاء",
    now: "الآن",
  },
  dsBasketCondition: {
    title: "الحد الأدنى لشروط سلة التسوق",
    items: {
      NoConditions: "بدون قيود",
      MinimumShopping: "الحد الأدنى لمبلغ سلة التسوق",
      MinimumProduct: "الحد الأدنى لعدد المنتجات في سلة التسوق",
      MaximumShopping: "الحد الأقصى لمبلغ سلة التسوق",
      MaximumProduct: "الحد الأقصى لعدد المنتجات في سلة التسوق",
    },
  },
  dsUserSettings: {
    title: "الحد الأدنى لشروط سلة التسوق",
    groupTitle: "المستخدمون الذين",
    specialTitle: "مستخدم",
    labels: {
      minimumCart: "الحد الأدنى لشروط السلة",
      users: "مستخدمون",
    },
    items: {
      AllUser: "جميع المستخدمين",
      group: "مجموعة من المستخدمين",
      special: "مستخدمون خاصون",
    },
    groupItems: {
      Order: "المستخدمون الذين اشتروا سابقًا",
      noOrder: "المستخدمون الذين لم يشتروا سابقًا",
    },
  },
  qrAddressUpdate: {
  title: "تعديل العنوان",
  labels: {
    address: "عنوان QR",
  },
  hints: {
    allowedChars: "يُسمح فقط بالأحرف الإنجليزية والأرقام والشرطة (-) والشرطة السفلية (_)",
  },
  buttons: {
    removeInvalidChars: "إزالة الأحرف غير المسموح بها",
  },
  errors: {
    minLength: "يجب إدخال 3 أحرف على الأقل",
    invalidChars: "حرف غير صالح! استخدم الأحرف الإنجليزية والأرقام و- و_ فقط.",
    invalidAddress: "العنوان المدخل غير صالح",
    updateFailed: "حدث خطأ أثناء تحديث العنوان",
  },
  successMessage: "تم تحديث العنوان بنجاح",
  warning: "تحذير",
  warningMessage: "سيؤدي تغيير العنوان إلى تعطيل الروابط السابقة.",
  savePrompt: "هل أنت متأكد من رغبتك في حفظ هذا التغيير؟",
},
  dsFunctionType: {
    title: "تطبيق الخصم على",
    productListTitle: "قائمة المنتجات",
    categoryListTitle: "قائمة الفئات",
    labels: {
      applyDiscount: "تطبيق الخصم على",
      category: "فئة",
    },
    items: {
      AllShoppingCart: "إجمالي مبلغ سلة التسوق",
      SpecialProducts: "منتجات خاصة",
      SpecialCategories: "فئة خاصة",
    },
  },
  dsLimitationUse: {
    title: "حد الاستخدام",
    discountCodeTitle: "عدد الاستخدام",
    userTitle: "عدد المستخدم",
    labels: {
      limitation: "حد",
      usage: "استخدام",
      user: "مستخدم",
    },
    items: {
      NoLimitations: "بدون قيود",
      DiscountCode: "عدد استخدام كود الخصم",
      User: "عدد الاستخدام لكل مستخدم",
    },
  },
  ManageHourLimitQr: {
    noLimit: "بدون حد",
    dateLimit: "حد تاريخ",
    timeLimit: "حد ساعة",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    selectDate: "اختيار تاريخ",
    startTime: "ساعة البدء",
    endTime: "ساعة الانتهاء",
  },
  discount_percent_range: "يجب أن يكون الخصم بين 0 و100 بالمئة",
  discount_price_range: "يجب أن يكون الخصم بين 0 و{max}",
  invalid_number: "يرجى إدخال أرقام فقط",
  min_order_cart: "الحد الأدنى لسلة التسوق",
  preparation_time: "وقت التحضير (دقيقة)",
  delivery_time: "وقت التوصيل (دقيقة)",
  max_product_in_order: "الحد الأقصى لعدد المنتج في كل طلب",
  max_order_by_person: "الحد الأقصى لعدد الطلبات لكل عميل",
  send_by_courier_price: "تكلفة المندوب",
  vat: "نسبة الضريبة",
  send_by_post: "تكلفة البريد",
  online_pay: "دفع عبر الإنترنت",
  pay_in_person_place: "دفع عند التسليم",
  in_place: "زيارة حضورية",
  table_booking_ability: "حجز طاولة",
  send_by_courier: "إرسال مع مندوب",
  vat_switch: "ضريبة",
  invalid_number: "يرجى إدخال أرقام فقط",
  positive_number: "يجب أن يكون الرقم إيجابيًا",
  vat_range: "يجب أن تكون الضريبة بين 0 و100 بالمئة",
  sort_column: "عمود الترتيب",
  direction_sort: "اتجاه الترتيب",
  listFeedbackUser: {
    no_questions: "ليس لديك أسئلة لجمع التعليقات",
    add_feedback_prompt: "لإضافة تعليق جديد، راجع علامة التبويب إضافة",
    question_label: "سؤال",
    show_answers: "عرض الإجابات",
    back_button: "رجوع",
    no_feedback: "ليس لديك تعليق!",
    user_opinion: "رأي المستخدم",
    score_label: "نقاط",
  },
  manageDiscount: {
    createNewDiscount: "إنشاء كود خصم جديد",
    copy: "نسخ",
    row: "ترتيب",
    id: "معرف",
    discountCode: "كود الخصم",
    usageLimit: "سقف الاستخدام",
    used: "مستخدم",
    manage: "إدارة",
    edit: "تعديل",
    delete: "حذف",
    sendSms: "إرسال رسالة إلى الجمهور",
    copySuccess: "تم نسخ كود الخصم الخاص بك",
    copyError: "حدثت مشكلة",
    deleteSuccess: "تم حذف كود الخصم الخاص بك",
    deleteError: "خطأ في حذف كود الخصم",
    smsSuccess: "تم إرسال كود الخصم إلى الجمهور",
    smsError: "حدثت مشكلة",
  },
  manageTableReservation: {
    table: "طاولة",
    number: "رقم {num}",
    add_table: "إضافة طاولة",
    complete_info_for_customer: "أكمل المعلومات أدناه لعرضها للعميل",
    select_image: "اختيار صورة",
    table_name_number: "اسم/رقم الطاولة",
    number_of_seats: "عدد مقاعد الطاولة",
    type: "نوع",
    reservation_cost: "تكلفة الحجز",
    enter_table_name: "يرجى إدخال اسم/رقم الطاولة",
    table_type: "طاولة",
    couch_type: "سرير",
    gazebo_type: "شرفة",
  },
  create_menu: {
    data: {
      visitName_label: "اسم الزيارة",
      organizationName: "سلسلة فاست فود كبيرة",
      subOrgan: "جرب أفضل طعم فاست فود معنا",
      aboutUs:
        "فاست فود كبير مع الحفاظ على الجودة والاحترام لكم حاولنا توفير الأفضل لكم.\nالحفاظ على الجودة من المبادئ التي نحن ملتزمون بها ونحن.\nفي قسم الفاست فود حتى الآن مع ساندويتشات خاصة كنا طعمًا جديدًا في خط الطعام الفاست فودي لكم\nنحن جاهزون كل يوم لخدمتكم للاجتماعات الإدارية، أعياد الميلاد و... لكم.",
      copyright: "جميع حقوق هذا الموقع تعود إلى محطة الإعلانات.",
      product: {
        title: "منتجات",
        pizzas: "بيتزات",
        pizza_roast_beef: "بيتزا روست بيف",
        pizza_roast_beef_desc: "🤩بيتزا إيطالية بلحم البقر",
        pizza_roast_beef_ingredients:
          "عجينة بيتزا إيطالية 30 سم، 100 غرام لحم بقر مفروم، فطر، فلفل دلمي، زيتون أسود",
        pizza_chicken_mushroom: "بيتزا دجاج وفطر",
        pizza_chicken_mushroom_desc: "🍕كلاسيك 40 سم",
        pizza_chicken_mushroom_ingredients:
          "صلصة طماطم طازجة بيتزارا، جبن (مطهر)، فيليه دجاج، فطر، زعتر جبلي",
        pizza_meat_mushroom: "بيتزا لحم وفطر",
        pizza_meat_mushroom_desc: "🥰 بيتزا لحم مفروم مع فطر",
        pizza_meat_mushroom_ingredients:
          "صلصة طماطم طازجة بيتزارا، جبن (مطهر)، لحم راسته بقر مفروم، فطر، زعتر جبلي، لشخصين (29 سم) 355,000 تومان، لشخص واحد (22 سم) 216,000 تومان",
        pizza_veggie: "بيتزا خضروات",
        pizza_veggie_desc: "🍕 بيتزا خضروات أمريكية",
        pizza_veggie_ingredients:
          "عجينة بيتزا أمريكية، ذرة، فطر، زيتون، طماطم، بصل، فلفل، جبن بيتزا",
        pizza_special: "بيتزا خاصة",
        pizza_special_desc: "بيتزا خاصة أمريكية",
        pizza_special_ingredients:
          "عجينة بيتزا أمريكية، لحم بقر مفروم مُتبل، مزيج هامبورغر لحم ودجاج 80%، جبن موزاريلا مزيج، صلصة خاصة، فلفل دلمي، فطر، بدون صلصة لشخص واحد",
        pizza_bolognese: "بيتزا بولونيز",
        pizza_bolognese_desc: "(لشخص واحد) عجينة بيتزا 23 سم 🤌",
        pizza_bolognese_ingredients:
          "لحم بقر مفروم، جبن موزلا، فطر، فلفل دلمي، ذرة، زيتون أسود مقطع",
        pizza_pepperoni: "بيتزا بيبروني",
        pizza_pepperoni_desc: "(لشخص واحد) عجينة بيتزا 23 سم",
        pizza_pepperoni_ingredients:
          "عجينة بيتزا إيطالية، بيبروني 80%، صلصة مينارا، جبن بيتزا خاص",
        pizza_bacon: "بيتزا بيكون",
        pizza_bacon_desc: "(لشخص واحد) عجينة بيتزا 23 سم 💥",
        pizza_bacon_ingredients:
          "عجينة بيتزا إيطالية، صلصة مارينارا، جبن بيتزا خاص، بيكون مزيج لحم ودجاج 90%، فطر، زيتون، فلفل دلمي",
        pizza_mixed: "بيتزا مختلطة",
        pizza_mixed_desc: "(لشخص واحد) عجينة بيتزا 23 سم 🤭",
        pizza_mixed_ingredients:
          "مزيج هامبورغر لحم ودجاج مقطع، سالامي، لحم بقر مفروم، فطر، زيتون، فلفل دلمي، جبن بيتزا، صلصة خاصة",
        pizza_american_steak: "بيتزا ستيك أمريكية",
        pizza_american_steak_desc: "(لشخص واحد) 23 سم 💥",
        pizza_american_steak_ingredients:
          "عجينة بيتزا أمريكية، لحم بقر قطع، فطر، جبن بيتزا، سمسم",
        burgers: "هامبرغر",
        cheeseburger: "تشيز برغر",
        cheeseburger_desc: "🤩مع بطاطس مقلية",
        cheeseburger_ingredients:
          "2 قطع برغر لحم بقر 150 غرام، صلصة خاصة، جبن غودا، مخلل خيار، خس، طماطم",
        hamburger: "هامبرغر",
        hamburger_desc: "😍لحم خالص مع صلصة خاصة",
        hamburger_ingredients:
          "قطعة برغر لحم بقر 150 غرام، مخلل خيار، خس، صلصة خاصة، طماطم، خبز ماك، صلصة لشخص واحد",
        chicken_burger: "تشيكن برغر",
        chicken_burger_desc: "تشيكن برغر مشوي مع جبن",
        chicken_burger_ingredients:
          "150 غرام صدر دجاج مشوي، جبن، طماطم، مخلل خيار، خس، خبز ماك، صلصة خاصة",
        spice_burger: "سبايس برغر",
        spice_burger_desc: "لحم بقر مع صلصة سبايسي",
        spice_burger_ingredients:
          "قطعة برغر لحم بقر 130 غرام، صلصة سبايسي، خس، طماطم، خبز ماك، صلصة خاصة سبايسي",
        double_burger: "دبل برغر",
        double_burger_desc: "لحم بقر 150 غرام",
        double_burger_ingredients:
          "2 قطع برغر يدوي لحم بقر 150 غرام، جبن بيتزا، صلصة كراميل، خس، كرنب، صلصة بيضاء خاصة، خبز دائري",
        royal_burger: "رويال برغر",
        royal_burger_desc: "150 غرام لحم بقر 🍔",
        royal_burger_ingredients:
          "قطعة برغر يدوي لحم بقر 150 غرام، جبن بيتزا، 5 شرائح سالامي، صلصة كراميل، خس، كرنب، صلصة بيضاء خاصة، خبز دائري",
        mushroom_burger: "مشروم برغر",
        mushroom_burger_desc: "لحم بقر 150 غرام",
        mushroom_burger_ingredients:
          "قطعة برغر يدوي لحم بقر 150 غرام، فطر، صلصة كراميل، خس، كرنب، صلصة بيضاء خاصة، خبز دائري، جبن موزلا",
        mashroom_burger: "ماشروم برغر",
        mashroom_burger_desc: "لحم بقر مشوي 100%🤩",
        mashroom_burger_ingredients:
          "قطعة برغر يدوي لحم بقر مشوي 100%، بطاطس مقلية، طماطم، خس، مخلل خيار، صلصة فطر، خبز دائري",
        fried_burger: "برغر مقلي",
        fried_burger_desc: "لحم بقر مشوي مقلي 100%👌",
        fried_burger_ingredients:
          "قطعة برغر يدوي لحم بقر مشوي مقلي 100%، 150 غرام بطاطس مقلية، طماطم، خس، مخلل خيار، صلصة خاصة، خبز دائري",
        fried: "مقلي",
        fried_chicken: "دجاج مقلي",
        fried_chicken_desc: "😍دجاج مقلي ثلاث قطع",
        fried_chicken_ingredients:
          "3 قطع دجاج مقلي، 120 إلى 150 غرام بطاطس مقلية، سلطة كرنب 100 إلى 120 غرام، خبز بروتشن، صلصة خاصة",
        chicken_strips: "تشيكن ستريبس",
        chicken_strips_desc: "4 قطع فيليه مقلي مُتبل حار",
        chicken_strips_ingredients:
          "4 قطع فيليه دجاج مقلي، 120 إلى 150 غرام بطاطس مقلية، سلطة كرنب 100 إلى 120 غرام، خبز بروتشن، صلصة تارتار",
        fried_filet: "فيليه مقلي",
        fried_filet_desc: "🤩قطعتان فيليه مقلي مع صلصة خاصة",
        fried_filet_ingredients:
          "قطعتا ستريبس، بطاطس مشوية، سلطة كرنب، خبز بروتشن، صلصة ثوم، صلصة تشيلي تاي، صلصة فلفل",
        fried_mushroom_onion: "فطر وبصل مقلي",
        fried_mushroom_onion_desc: "🤩فطر وبصل مقلي مع صلصة تاتار",
        fried_mushroom_onion_ingredients:
          "20 قطعة فطر مقلي، 6 قطع بصل مقلي، صلصة تاتار",
        fried_wings: "أجنحة مقلية",
        fried_wings_desc: "6 قطع أجنحة مقلية 🍗",
        fried_wings_ingredients: "ست قطع أجنحة مشوية مقلية",
        fried_chicken_basket: "سلة دجاج مقلي",
        fried_chicken_basket_desc: "(لشخصين)😍",
        fried_chicken_basket_ingredients:
          "2 قطع دجاج مقلي، 2 قطع ستريبس، 2 قطع بصل حلقي، 2 قطع ناغت جمبري مقلي، 2 قطع ناغت دجاج",
        fried_schnitzel: "شنيتسل مقلي",
        fried_schnitzel_desc: "أربع قطع شنيتسل دجاج💥",
        fried_schnitzel_ingredients: "أربع قطع شنيتسل دجاج مقلي مشوي سبايسي",
        veggie_basket_fried: "سلة خضروات مقلية",
        veggie_basket_fried_desc: "250 غرام🤩",
        veggie_basket_fried_ingredients:
          "250 غرام، كوسا مقلي، باذنجان مقلي، فطر مقلي، بطاطس مقلية",
        fried_chicken_2_piece: "دجاج مقلي قطعتين",
        fried_chicken_2_piece_desc: "2 قطع دجاج مقلي🍗",
        fried_chicken_2_piece_ingredients:
          "120 إلى 150 غرام بطاطس مقلية، سلطة كرنب 100 إلى 120 غرام، خبز بروتشن، صلصة خاصة",
        fried_chicken_5_piece: "دجاج مقلي خمس قطع",
        fried_chicken_5_piece_desc: "خمس قطع دجاج مقلي",
        fried_chicken_5_piece_ingredients:
          "150 إلى 200 غرام بطاطس مقلية، سلطتا كرنب 100 إلى 120 غرام، خبزان بروتشن، صلصة خاصة",
        fried_chicken_7_piece: "دجاج مقلي سبع قطع",
        fried_chicken_7_piece_desc: "سبع قطع دجاج مقلي 💥",
        fried_chicken_7_piece_ingredients:
          "150 إلى 200 غرام بطاطس مقلية، سلطة كرنب 100 إلى 120 غرام، 3 خبز بروتشن، صلصة خاصة، صلصة لشخص واحد مقلي",
        sandwich: "ساندويتش",
        hotdog_sandwich: "ساندويتش هوت دوغ",
        hotdog_sandwich_desc: "ساندويتش هوت دوغ مع فطر وجبن",
        hotdog_sandwich_ingredients:
          "سجق هوت دوغ مشوي، خس، طماطم، مخلل خيار، فطر وجبن بيتزا",
        roast_beef_sandwich: "ساندويتش روست بيف",
        roast_beef_sandwich_desc: "✔️لحم بقر مفروم",
        roast_beef_sandwich_ingredients:
          "لحم بقر، جبن بيتزا، فطر، شيبس شرائح، خس، طماطم، مخلل خيار، صلصة خاصة، خبز فرنسي",
        ham_sandwich: "ساندويتش هام",
        ham_sandwich_desc: "ساندويتش هام دجاج وفطر (بارد)",
        ham_sandwich_ingredients:
          "هام فطر ودجاج، خس، طماطم، مخلل خيار، شيبس شرائح، صلصة خاصة، خبز باغيت",
        bandari_sausage_sandwich: "ساندويتش بندري",
        bandari_sausage_sandwich_desc: "💥ساندويتش بندري حار",
        bandari_sausage_sandwich_ingredients:
          "طبق بندري مع سجق كوكتيل مدخن 55%، طماطم، مخلل خيار، صلصة خاصة، بصل وكزبرة، خبز بولكي",
        tongue_mushroom_sandwich: "ساندويتش لسان وفطر",
        tongue_mushroom_sandwich_desc: "150 غرام لسان بقر",
        tongue_mushroom_sandwich_ingredients:
          "فطر، جبن بيتزا مطهر، زيتون، ذرة، خس، مخلل خيار، طماطم، صلصة، جانب، بطاطس مقلية، سلطة كرنب",
        falafel_sandwich: "ساندويتش فلافل",
        falafel_sandwich_desc: "ست قطع فلافل🌭",
        falafel_sandwich_ingredients:
          "ست قطع فلافل، مخلل خيار، طماطم، خس، صلصة لشخص واحد، جانب، بطاطس مقلية، سلطة كرنب",
        cheesy_kebab_turki_sandwich: "ساندويتش كباب تركي جبني",
        cheesy_kebab_turki_sandwich_desc: "150 غرام لحم بقر",
        cheesy_kebab_turki_sandwich_ingredients:
          "150 غرام لحم بقر، جبن بيتزا خاص، مخلل خيار، طماطم، خس، صلصة لشخص واحد، بطاطس مقلية، سلطة كرنب",
        roast_chicken_sandwich: "ساندويتش روست دجاج",
        roast_chicken_sandwich_desc: "شنيتسل دجاج وفطر🤩",
        roast_chicken_sandwich_ingredients:
          "شنيتسل دجاج وفطر، جبن بيتزا خاص، زيتون، ذرة، سمسم، خس، فلفل دلمي، مخلل خيار، طماطم، صلصة خاصة، جانب، بطاطس مقلية",
        cheesy_indian_sandwich: "ساندويتش هندي جبني",
        cheesy_indian_sandwich_desc: "سجق ألماني💥",
        cheesy_indian_sandwich_ingredients:
          "سجق ألماني جبني، ذرة، خس، فطر، صلصة خاصة، جانب، بطاطس مقلية، سلطة كرنب",
        snack: "سناك",
        chicken_snack: "سناك دجاج",
        chicken_snack_desc: "😋صدر دجاج مفروم",
        chicken_snack_ingredients:
          "150 غرام صدر دجاج، فلفل دلمي، فطر، خبز سناك خاص، صلصة خاصة",
        meat_snack: "سناك لحم",
        meat_snack_desc: "🥪زوج سناك لحم",
        meat_snack_ingredients:
          "زوج، فخذ بقر مفروم، جبن موزاريلا، ذرة، فلفل دلمي، صلصة خاصة، خبز توست",
        chicken_meat_snack: "سناك تشيكن ميت",
        chicken_meat_snack_desc: "🤩زوج سناك تشيكن ميت",
        chicken_meat_snack_ingredients:
          "زوج، صدر دجاج مفروم، فخذ بقر مفروم، جبن موزاريلا، ذرة، فلفل دلمي، صلصة خاصة، خبز توست",
        special_snack: "سناك خاص",
        special_snack_desc: "🤤 زوج سناك خاص",
        special_snack_ingredients:
          "زوج، مزيج كالباس لحم ودجاج 90٪، جبن موزاريلا، ذرة، فلفل دلمي، صلصة خاصة، خبز توست",
        roast_beef_snack: "سناك روست بيف",
        roast_beef_snack_desc: "لحم بقر مفروم🍖",
        roast_beef_snack_ingredients:
          "لحم بقر مفروم، فطر، جبن بيتزا، فلفل دلمي، ذرة، جانب، بطاطس مقلية، سلطة كرنب",
        veggie_snack: "سناك خضروات",
        veggie_snack_desc: "سناك خضروات 4 قطع",
        veggie_snack_ingredients:
          "بروكولي، ذرة، زيتون، جبن بيتزا دايت، فطر، جانب، بطاطس مقلية، سلطة كرنب",
        chicken_mushroom_snack: "سناك دجاج وفطر",
        chicken_mushroom_snack_desc: "شنيتسل دجاج وفطر👌",
        chicken_mushroom_snack_ingredients:
          "شنيتسل دجاج، فطر، جبن بيتزا خاص، زيتون، ذرة، فلفل دلمي، جانب، بطاطس مقلية، سلطة كرنب",
        pepperoni_snack: "سناك بيبروني",
        pepperoni_snack_desc: "كالباس بيبروني 90%💥",
        pepperoni_snack_ingredients:
          "زوج، كالباس بيبروني 90%، جبن موزاريلا، ذرة، فلفل دلمي، صلصة خاصة",
        bologna_snack: "سناك بلونيا",
        bologna_snack_desc: "لحم مفروم👌",
        bologna_snack_ingredients:
          "زوج، لحم مفروم، بيكون خاص، فطر بلانش، ذرة، جبن موزاريلا، فلفل دلمي، صلصة خاصة",
        pasta: "باستا",
        alfredo_pasta: "باستا ألفردو",
        alfredo_pasta_desc: "باستا ألفردو مع صلصة فطر خاصة",
        alfredo_pasta_ingredients: "350 غرام بيني",
        macaroni: "مكرونة",
        macaroni_desc: "🥣مكرونة لحم وفطر",
        macaroni_ingredients:
          "مكرونة شرائط 1.2، لحم بقر مفروم 100 غرام، فطر، فلفل دلمي، بطاطس مكعبات مقلية، بازلاء",
        spaghetti_bolognese: "سباغيتي بلونز",
        spaghetti_bolognese_desc: "🥰باستا لينغويني",
        spaghetti_bolognese_ingredients:
          "700 غرام، باستا لينغويني، لحم بقر وغنم مفروم، صلصة بلونز، صلصة حمراء رسو خاصة، ملعقة وشوكة بلاستيكية حسب اختيارك",
        chicken_stroganoff: "تشيكن ستروغانوف",
        chicken_stroganoff_desc: "😍تشيكن ستروغانوف مع صدر دجاج قطع",
        chicken_stroganoff_ingredients:
          "180 غرام صدر دجاج قطع مُتبل، قشدة، فطر بلانش، جبن بارميزان، بطاطس مقلية شرائح يدوية، وعاء ميكروويف خاص",
        penne_arrabbiata: "باستا بيني أرابياتا",
        penne_arrabbiata_desc: "صدر دجاج💥",
        penne_arrabbiata_ingredients:
          "لشخص واحد، صدر دجاج، باستا، فطر، جبن بارميسان، طماطم شيري، بقدونس، صلصة أرابياتا",
        chicken_pesto_pasta: "باستا تشيكن بيستو",
        chicken_pesto_pasta_desc: "(لشخص واحد) صدر دجاج",
        chicken_pesto_pasta_ingredients:
          "صدر دجاج، فطر، جبن بارميسان، طماطم شيري، بقدونس، صلصة أرابياتا",
        carbonara_pasta: "باستا كاربونارا",
        carbonara_pasta_desc: "بيكون لحم 97%",
        carbonara_pasta_ingredients:
          "باستا، بيكون لحم 97%، صلصة ألفردو، جبن بارميسان، طماطم شيري، بقدونس",
        appetizer: "مقبلات",
        hot_chips: "هوت شيبس",
        hot_chips_desc: "😙بنكهات مختلفة من الشيبس",
        hot_chips_ingredients:
          "كيلوغرام شيبس، صلصة خاصة، هام دجاج 70%، فطر، فلفل دلمي، جبن بيتزا، جبن غودا",
        lasagna: "لازانيا",
        lasagna_desc: "لازانيا بلحم مفروم",
        lasagna_ingredients:
          "3 ورق لازانيا، لحم مفروم، فطر، فلفل دلمي، زيتون أسود، جبن بيتزا، صلصة خاصة",
        french_fries: "بطاطس مقلية",
        french_fries_desc: "بطاطس مقلية مع صلصة خاصة",
        french_fries_ingredients: "150 غرام بطاطس مقلية، صلصة خاصة",
        baked_potato: "بطاطس مشوية",
        baked_potato_desc: "🍟 بطاطس مشوية مع لحم مقدد بقري",
        baked_potato_ingredients:
          "150 غرام بطاطس مقلية، لحم مقدد بقري 90%، جبنة بيتزا، توابل خاصة، صلصة لشخص واحد",
        garlic_bread: "خبز بالثوم",
        garlic_bread_desc: "صلصة ثوم خاصة💥",
        garlic_bread_ingredients:
          "عجينة بيتزا أمريكية، مزيج جبنة بيتزا، صلصة ثوم خاصة، سمسم",
        silo_potatoes: "بطاطس سيلو",
        silo_potatoes_desc: "بطاطس مقلية لشخصين",
        silo_potatoes_ingredients:
          "بطاطس مقلية بنكهة سيلو، لحم مقدد بقري 97%، صلصة شيدر، آيولي، بصل أخضر، بقدونس",
        bbq_sausage: "سجق مشوي",
        bbq_sausage_desc: "سجق أصابع متبل🍢",
        bbq_sausage_ingredients:
          "500 غرام هريس بطاطس متبل، 200 غرام سجق أصابع متبل، حلقات بصل، زيتون أخضر، بودرة جبنة بارميزان، طماطم كرزية، خضار صغيرة، جبنة قابلة للشوي، صلصة باربيكيو، حار",
        silo_toast: "توست سيلو",
        silo_toast_desc: "160 غرام شرائح لحم بقري رفيعة🤩",
        silo_toast_ingredients:
          "160 غرام شرائح لحم بقري رفيعة، خس فرنسي، لحم مقدد بقري، خبز ريفي، صلصة باربيكيو، صلصة تارتار، حميض، زيتون أخضر، خضار صغيرة، آيولي، بودرة جبنة بارميزان",
        salad_and_dessert: "سلطة وحلوى",
        caesar_salad: "سلطة سيزر",
        caesar_salad_desc: "سلطة سيزر لشخص واحد🥗",
        caesar_salad_ingredients:
          "مزيج خس، دجاج مشوي، جبنة بارميزان، خبز محمص (خبز بالثوم)، صلصة سيزر، زيتون",
        caesar_salad_extra: "خس روماني، خبز محمص، بارميزان",
        coleslaw_salad: "سلطة كرنب",
        coleslaw_salad_desc: "سلطة كرنب لشخص واحد🍴",
        coleslaw_salad_ingredients: "صنع يدوي، لشخص واحد، كرنب أبيض، ذرة، صلصة",
        macaroni_salad: "سلطة معكرونة",
        macaroni_salad_desc: "سلطة معكرونة مع لحم خنزير منزلي",
        macaroni_salad_ingredients: "معكرونة، لحم خنزير منزلي",
        pachira_salad: "سلطة باتشيرا",
        pachira_salad_desc: "سلطة باتشيرا لشخصين🥗",
        pachira_salad_ingredients:
          "لشخصين، مزيج خس، رقائق لحم مقدد بقري 98%، جوز مكرمل، جبنة بارميزان، فراولة، كافيار نباتي، زبيب، شرائح ليمون، صلصة توت وردي",
        greek_salad: "سلطة يونانية",
        greek_salad_desc: "سلطة يونانية تقليدية مع جبنة فيتا وزيتون",
        greek_salad_ingredients: "جبنة فيتا، زيتون، خيار",
        tiramisu: "تيراميسو",
        tiramisu_desc: "حلوى تيراميسو إيطالية كلاسيكية",
        tiramisu_ingredients: "قهوة، ماسكاربوني، كاكاو",
        beverages: "مشروبات",
        local_yogurt_drink: "مشروب زبادي محلي",
        local_yogurt_drink_desc: "مشروب زبادي محلي عائلي🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "مشروب غازي أسود",
        black_soda_desc: "كأس مشروب غازي أسود🧋",
        black_soda_ingredients: "",
        fanta: "مشروب غازي أصفر",
        fanta_desc: "كأس مشروب غازي أصفر🥤",
        fanta_ingredients: "",
        mojito: "موهيتو",
        mojito_desc: "كأس موهيتو، من 350 إلى 400 مل🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "مشروب شعير استوائي",
        tropical_malt_beverage_desc: "كأس مشروب شعير استوائي🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "العنوان",
        address_text: "أدخل رابط الموقع المرغوب",
        instagram_label: "إنستغرام",
        instagram_text: "أدخل اسم المستخدم الخاص بك",
        whatsapp_label: "واتساب",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "معرض الفيديو",
        description:
          "للتعرف أكثر على خدمات نظام كيو آر لاند الذكي، يرجى مشاهدة الفيديوهات أدناه.",
        tutorial: "تعليمي",
        fast_food: "طعام سريع",
      },
      feedback: {
        title: "رأيك",
        description:
          "يرجى الإجابة على الأسئلة أدناه لمساعدتنا في تحسين خدماتنا",
        question1: "ما مدى رضاك عن خدماتنا وجودة الطعام؟",
        question2: "كيف تقيم تنوع الأطباق في المطعم؟",
        question3: "كيف تقيم سلوك موظفي المطعم؟",
        question4: "هل تم تسليم الطعام في الوقت المحدد؟",
        question5: "هل لديك اقتراحات لتحسين خدماتنا أو جودة الطعام؟",
      },
      worksheet: {
        saturday: "السبت",
        sunday: "الأحد",
        monday: "الإثنين",
        tuesday: "الثلاثاء",
        wednesday: "الأربعاء",
        thursday: "الخميس",
        friday: "الجمعة",
        shift_1_saturday: "من 10:00 إلى 22:00",
        shift_1_sunday: "من 10:00 إلى 22:00",
        shift_1_monday: "من 10:00 إلى 22:00",
        shift_1_tuesday: "من 10:00 إلى 22:00",
        shift_1_wednesday: "من 10:00 إلى 00:00",
        shift_1_thursday: "من 10:00 إلى 00:00",
        shift_1_friday: "من 10:00 إلى 00:00",
      },
      gallery: {
        gallery_0: "معرض 0",
        image_1: "1",
        image_2: "2",
        image_3: "3",
        image_4: "4",
        image_5: "5",
        baked_potato_2: "بطاطس مشوية 2",
        chicken_stroganoff_1: "دجاج ستروغانوف 1",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "طهران، شارع شريعتي، بعد جسر سيد خندان، زقاق خندان، رقم 6، وحدة 3",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "إيران، طهران، مدينة طهران، طهران، المنطقة 3 بمدينة طهران، حي سيد خندان، دكتور علي شريعتي، خندان",
      },
    },
    messages: {
      qr_created_success: "تم إنشاء القائمة عبر الإنترنت بنجاح.",
      qr_updated_success:
        "تم تعديل رمز الاستجابة السريعة للقائمة عبر الإنترنت بنجاح.",
      qr_create_error: "حدث خطأ أثناء إنشاء رمز الاستجابة السريعة!",
      qr_update_error: "خطأ في حفظ/تعديل رمز الاستجابة السريعة",
      template_categories_saved: "تم حفظ فئات النموذج النموذجي بنجاح.",
      template_products_saved: "تم حفظ منتجات النموذج النموذجي بنجاح.",
      template_categories_error: "خطأ في حفظ فئات النموذج النموذجي!",
      template_products_error: "خطأ في حفظ منتجات النموذج النموذجي!",
    },
    sample_menu: "قائمة نموذجية",
    view_qr: "عرض رمز الاستجابة السريعة",
    preview: "معاينة",
    download_qr: "تنزيل رمز الاستجابة السريعة",
    create_qr: "إنشاء رمز استجابة سريعة",
    online_menu_name: "اسم القائمة عبر الإنترنت",
    online_menu_name_short: "اسم القائمة",
    enter_qr_address: "أدخل عنوان رمز الاستجابة السريعة",
    qr_address: "عنوان رمز الاستجابة السريعة",
    enter_menu_information: "أدخل معلومات القائمة",
    cleardefaults: "مسح الإعدادات الافتراضية",
    select_sample_menu: "اختر قائمة نموذجية",
    select_ready_menu: "اختر قائمة جاهزة",
    online_sales: "المبيعات عبر الإنترنت",
    sales_settings: "إعدادات المبيعات",
    download: "تنزيل",
    gallery_photos: "صور المعرض",
    fast_food_1: "صورة طعام سريع 1",
    fast_food_2: "صورة طعام سريع 2",
    large_chain_fast_food: "سلسلة طعام سريع كبيرة",
    best_fast_food_taste_experience: "جرب أفضل طعم طعام سريع معنا",
    online_menu_created_successfully: "تم إنشاء القائمة عبر الإنترنت بنجاح.",
    qr_creation_failed: "حدث خطأ أثناء إنشاء رمز الاستجابة السريعة!",
    online_menu_qr_updated_successfully:
      "تم تعديل رمز الاستجابة السريعة للقائمة عبر الإنترنت بنجاح.",
    error_saving_updating_qr: "خطأ في حفظ/تعديل رمز الاستجابة السريعة",
    sample_model_categories_saved_successfully:
      "تم حفظ فئات النموذج النموذجي بنجاح.",
    sample_model_products_saved_successfully:
      "تم حفظ منتجات النموذج النموذجي بنجاح.",
    error_saving_sample_model_products: "خطأ في حفظ منتجات النموذج النموذجي!",
    error_saving_sample_model_categories: "خطأ في حفظ فئات النموذج النموذجي!",
  },
  editMenu: {
    enter_menu_information: "أدخل معلومات القائمة",
    online_menu_name: "اسم القائمة عبر الإنترنت",
    online_menu_name_short: "اسم القائمة المختصر",
    fields: {
      qr_address_hint:
        "عنوان رمز الاستجابة السريعة للوصول إلى القائمة عبر الإنترنت",
    },
    online_sales: "المبيعات عبر الإنترنت",
    sales_settings: "إعدادات المبيعات",
    shop: {
      upload_banner: "رفع لافتة",
      create_product: "إنشاء منتج",
      user_info: "معلومات المستخدم",
      add_social_media: "إضافة وسائل التواصل الاجتماعي",
      photo_gallery: "معرض الصور",
      video_gallery: "معرض الفيديو",
      feedback: "ملاحظات",
      working_hours: "ساعات العمل",
    },
    success_message: "تم تعديل بطاقتك الشخصية بنجاح.",
  },
  qrCodeSquare: {
    dots_color: "لون النقاط",
    gradient_color: "لون التدرج",
    linear: "خطي",
    radial: "دائري",
    color_rotation: "دوران اللون",
    first_color: "اللون الأول",
    second_color: "اللون الثاني",
    dots_color_label: "لون النقاط",
  },

  language: {
    selectAll: "اختر الكل",
    lang: {
      fa: "الفارسية",
      ar: "العربية",
      ar_ae: "العربية (الإمارات)",
      ar_iq: "العربية (العراق)",
      en_US: "الإنجليزية (أمريكا)",
      en_GB: "الإنجليزية (بريطانيا)",
      de: "الألمانية",
      fr: "الفرنسية",
      zh_CN: "الصينية المبسطة",
      zh_TW: "الصينية التقليدية",
      tr: "التركية",
      ru: "الروسية",
      hy: "الأرمنية",
    },
    only_manual_now: "في الوقت الحالي، الترجمة اليدوية فقط متاحة",
    ai_coming_soon: "ترجمة الذكاء الاصطناعي ستُفعَّل قريباً",
    got_it: "فهمت",
    origin_language: "اللغة الأصلية",
    target_languages: "اللغات المستهدفة",
    remove_all: "إزالة جميع اللغات",
    translation_method: "اختر طريقة الترجمة",
    manual_translation: "الترجمة اليدوية",
    ai_translation: "ترجمة الذكاء الاصطناعي",
    coming_soon: "قريباً",
    source_language_updated: "تم تحديث اللغة الأصلية",
    error_changing_source_language: "خطأ في تغيير اللغة الأصلية",
    source_language_created: "تم إنشاء لغة أصلية جديدة",
    languages_saved: "تم حفظ اللغات الجديدة",
    error_saving_languages: "خطأ في حفظ اللغات",
    error_loading_language: "خطأ في تحميل اللغة",
    languages_removed: "اللغات المحذوفة",
    new_languages_to_save: "لغات جديدة لحفظها",
    saved: "تم الحفظ",
    management_langs: "إدارة اللغات",
    add_langs: "إضافة لغة",
    change_language: "تغيير اللغة",
    visit_card: "بطاقة الزيارة",
    translate_to: "تُرجم إلى",
    main_language: "اللغة",
    no_languages_available: "لا توجد لغات متاحة",
    return_to_default: "العودة إلى اللغة الأصلية",
    translate: "ترجمة",
    changes_pending: "في انتظار تطبيق التغييرات",
    apply_changes: "تطبيق التغييرات",
    cancel_changes: "إلغاء",
  },
  winner_list: "قائمة الفائزين",
  qrwinnersList: {
    winnerstotalcount: "عدد الفائزين للـ QR",
    winnerscountoffilter: "عدد الفائزين مع الفلتر المُطبَّق",
    winnersList: "قائمة الفائزين بالـ QR",
    prize: "الجائزة",
    winnerName: "اسم الفائز",
    date: "التاريخ",
    noWinners: "لا يوجد فائزون",
    perPage: "عدد الصفوف في كل صفحة",
    search: "البحث حسب اسم الفائز أو الجائزة",
    sortDirection: "اتجاه الترتيب",
    sortBy: "الترتيب حسب",
  },
  appearance_settings: "إعدادات المظهر",
  header_color: "لون الرأس",
  background_color: "لون الخلفية",
  text_color: "لون النص",
  font_size: "حجم الخط",
  chat_logo: "شعار الدردشة",
  floating_button_icon: "أيقونة الزر العائم",
  assistant_name: "اسم المساعد",
  chat_preview: "معاينة الدردشة",
  smart_assistant: "المساعد الذكي",
  online: "متصل",
  aiChatSettings: {
    select_assistant: "اختيار المساعد",
    appearance_settings: "إعدادات المظهر",
    lead_connection_tab: "جمع العملاء المحتملين - الربط بنادي العملاء",

    header_settings: "إعدادات الترويسة",
    header_settings_desc: "لون وأسلوب ترويسة الدردشة",
    text_settings: "إعدادات النص",
    text_settings_desc: "لون النص وحجمه",
    logo_settings: "إعدادات الشعار",
    logo_settings_desc: "صورة أو أيقونة المساعد",
    background_settings: "إعدادات الخلفية",
    background_settings_desc: "صورة خلفية أو لون",

    gradient_color: "لون متدرج",
    solid_color: "لون صلب",
    use_image: "استخدام صورة",
    use_icon: "استخدام أيقونة",

    first_color: "اللون الأول",
    second_color: "اللون الثاني",
    header_color: "لون الترويسة",
    text_color: "لون النص",
    background_color: "لون الخلفية",

    font_size: "حجم الخط",

    robot: "روبوت",
    chat: "دردشة",
    support: "دعم",
    question: "سؤال",
    message: "رسالة",
    assistant_voice: "مساعد",
    ai_brain: "ذكاء اصطناعي",

    lead_connection_title: "الربط بنادي العملاء",
    lead_alert:
      "تحديد هذه الإعدادات سيؤدي إلى حفظ بيانات المستخدم في نادي العملاء عند اختياره إرسال عميل محتمل.",

    hasAssistantsName_label: "جمع الاسم",
    hasAssistantsName_hint: "جمع اسم المستخدم",
    hasAssistantsFamily_label: "جمع اسم العائلة",
    hasAssistantsFamily_hint: "جمع اسم العائلة للمستخدم",
    hasAssistantsMobile_label: "جمع رقم الجوال",
    hasAssistantsMobile_hint: "جمع رقم الجوال للمستخدم",
  },
  assistantChatViewer: {
    assistant_name: "المساعد الذكي",
    online: "متصل",
    new_chat: "دردشة جديدة",
    clear_chat: "مسح الدردشة",
    close: "إغلاق",
    message_placeholder: "رسالة...",
    processing: "جاري المعالجة...",
    renew: "تجديد",
    created_at: "تاريخ الإنشاء",
    last_edit: "آخر تعديل",
    copied: "تم النسخ",
    copy: "نسخ",
    print_qr: "طباعة الرمز",
    print_visit_card: "طباعة بطاقة الزيارة",
    send_link: "إرسال الرابط",
    winner_list: "قائمة الفائزين",
    customer_list: "قائمة العملاء",
    order_list: "قائمة الطلبات",
    reserved_appointments: "المواعيد المحجوزة",
    feedback: "ملاحظات",
    request_form: "نموذج طلب",
    transfer_ownership: "نقل الملكية",
    store_management: "إدارة المتجر",
    select_nfc_card: "اختيار بطاقة NFC",
    edit: "تعديل",
    design: "تصميم",
    qr_settings: "إعدادات الرمز",
    deactivate: "إلغاء التفعيل",
    download: "تحميل",
    viewed: "تمت المشاهدة مرات",
    see_more: "عرض المزيد",
    updating_qr: "جاري تحديث الرمز...",
  },
  create_game: "إنشاء لعبة",
  ready_games: "الألعاب الجاهزة",
  add_game: "إضافة لعبة",
  game_gallery: "معرض الألعاب",
  game_size_error: "حجم ملف اللعبة لا يجب أن يتجاوز 2 ميغابايت",
  game_upload_error: "خطأ في رفع اللعبة",
  no_game_available: "لا توجد ألعاب متاحة",
  to_use_ready_games_search_category_or_product:
    "لاستخدام الألعاب الجاهزة، ابحث حسب الفئة أو المنتج",
  gif_size_error: "حجم ملف الـGIF لا يجب أن يتجاوز 2 ميغابايت",
  previewer_page: "عرض المعاينة",
  // ─────────────────────────────────────────────────────
  // مفاتيح الترجمة لقسم اللعبة، الـGIF والإعدادات
  // الملف: src/core/services/langs/ar.js
  // اللغة: العربية الفصحى (Modern Standard Arabic)
  // ─────────────────────────────────────────────────────
  // 1. محرر اللعبة الرئيسي (PublicGameEditor)
  game_editor: "محرر اللعبة",
  reset_defaults: "إعادة التعيين إلى الافتراضي",
  save_and_preview: "حفظ وعرض مسبق",
  texts: "النصوص",
  images: "الصور",
  colors: "الألوان",
  general_settings: "الإعدادات العامة",
  gameplay_settings: "إعدادات آلية اللعب",
  effects: "التأثيرات",
  login_and_phone: "تسجيل الدخول ورقم الهاتف",
  no_settings_available_for_this_game_type:
    "لا تتوفر إعدادات لهذا النوع من اللعبة",
  confirm_reset: "تأكيد إعادة التعيين",
  reset_all_settings_to_default:
    "هل أنت متأكد من رغبتك في إعادة تعيين جميع الإعدادات إلى الافتراضي؟",
  yes_reset: "نعم، أعد التعيين",
  cancel: "إلغاء",
  settings_reset_successfully: "تم إعادة تعيين الإعدادات بنجاح",
  saved_and_ready_for_preview: "تم الحفظ وهو جاهز للعرض المسبق",

  // 2. تب تسجيل الدخول ورقم الهاتف (TabLogin)
  login_and_phone_settings: "إعدادات تسجيل الدخول ورقم الهاتف",
  ask_phone_after_game: "طلب رقم الهاتف بعد انتهاء اللعبة",
  phone_prompt_text: "نص طلب رقم الهاتف",
  phone_prompt_hint: "النص الذي يُعرض في مربع الحوار لطلب رقم الهاتف",
  submit_button: "زر الإرسال",
  login_dialog_logo: "شعار مربع حوار تسجيل الدخول",
  logo_url: "رابط الشعار",

  // 3. تب التأثيرات (TabEffect)
  game_effects_settings: "إعدادات تأثيرات اللعبة",
  sound_enabled: "تفعيل الصوت",
  volume: "مستوى الصوت",
  volume_hint: "مستوى صوت اللعبة (من 0 إلى 1)",
  oscillator_type: "نوع المذبذب",
  jump_sound_freq: "تردد صوت القفز",
  hit_sound_freq: "تردد صوت الاصطدام",
  powerup_sound_freq: "تردد صوت عنصر التعزيز",
  move_sound_freq: "تردد صوت الحركة",
  combo_base_freq: "تردد أساس الكومبو",
  sound_durations: "مدة الأصوات",
  move_duration_ms: "مدة صوت الحركة (ملي ثانية)",
  jump_duration_ms: "مدة صوت القفز (ملي ثانية)",
  combo_duration_ms: "مدة صوت الكومبو (ملي ثانية)",
  hit_duration_ms: "مدة صوت الاصطدام (ملي ثانية)",
  vibration_enabled: "تفعيل الاهتزاز",
  particles_enabled: "تفعيل الجسيمات",
  explosion_settings: "إعدادات انفجار الجسيمات",
  particle_count: "عدد الجسيمات",
  gravity: "الجاذبية",
  friction: "الاحتكاك",
  fade_speed: "سرعة التلاشي",

  // 4. تب الصور (TabImages)
  game_images_and_assets: "صور وأصول اللعبة",
  player_image: "صورة اللاعب",
  player: "اللاعب",
  powerup_image: "صورة عنصر التعزيز",
  qr_powerup: "عنصر تعزيز QR",
  enemy_images: "صور الأعداء",
  optional_multi: "اختياري، صور متعددة",
  enemies: "الأعداء",
  background_image: "صورة الخلفية",
  background: "الخلفية",
  phone_frame_background: "خلفية إطار الهاتف",
  phone_frame: "إطار الهاتف",
  winner_background: "خلفية الفائز",
  winner: "الفائز",
  ground_image: "صورة الأرضية",
  ground: "الأرضية",
  player_character: "شخصية اللاعب",
  far_background_layer: "طبقة الخلفية البعيدة",
  background_far: "الخلفية البعيدة",
  near_background_layer: "طبقة الخلفية القريبة",
  background_near: "الخلفية القريبة",
  obstacle_images: "صور العوائق",
  multi_optional: "صور متعددة، اختياري",
  obstacles: "العوائق",

  // 5. تب النصوص (TabTexts)
  game_text_contents: "محتوى النصوص في اللعبة",
  main_screen_texts: "نصوص الشاشة الرئيسية",
  game_title: "عنوان اللعبة",
  game_subtitle: "العنوان الفرعي للعبة",
  start_button: "زر البدء",
  score_label: "تسمية النقاط",
  game_over_screen: "شاشة نهاية اللعبة",
  game_over_title: "عنوان نهاية اللعبة",
  game_over_subtitle: "العنوان الفرعي لنهاية اللعبة",
  phone_prompt: "طلب رقم الهاتف",
  restart_button: "زر إعادة البدء",
  hud_and_labels: "عناصر العرض العلوي والتسميات",
  level_label: "تسمية المستوى",
  combo_label: "تسمية الكومبو",
  final_score_label: "تسمية النقاط النهائية",
  high_score_label: "تسمية أعلى نقاط",
  messages_and_popups: "الرسائل والنوافذ المنبثقة",
  new_record_message: "رسالة رقم قياسي جديد",
  fun_random_messages: "رسائل عشوائية ممتعة",
  add_new_message: "إضافة رسالة جديدة",

  // 6. تب الإعدادات العامة (TabSetting)
  general_game_settings: "الإعدادات العامة للعبة",
  enemy_spawn_rate: "معدل ظهور الأعداء",
  frames_between_enemies_spawn: "عدد الإطارات بين ظهور كل عدو",
  powerup_spawn_rate: "معدل ظهور عناصر التعزيز",
  frames_between_qr_spawn: "عدد الإطارات بين ظهور QR",
  win_score_threshold: "حد النقاط للفوز",
  score_required_for_win_or_phone_prompt:
    "النقاط المطلوبة للفوز أو عرض طلب الهاتف",
  starting_lives: "عدد الأرواح الابتدائية",
  high_score_storage_key: "مفتاح تخزين أعلى نقاط",
  phone_prompt_score_threshold: "حد النقاط لطلب رقم الهاتف",
  score_to_show_phone_number_form: "النقاط اللازمة لعرض نموذج رقم الهاتف",
  no_general_settings_available_for_this_game:
    "لا تتوفر إعدادات عامة لهذه اللعبة",

  // 7. تب آلية اللعب (TabGamePlay)
  speed_settings: "إعدادات السرعة",
  initial_speed: "السرعة الابتدائية",
  max_speed: "السرعة القصوى",
  speed_increase_every_frames: "زيادة السرعة كل عدد من الإطارات",
  speed_increase_amount: "مقدار زيادة السرعة",
  distance_per_level: "المسافة لكل مستوى",
  level_speed_increase: "زيادة السرعة لكل مستوى",
  jump_and_physics: "القفز والفيزياء",
  jump_force: "قوة القفز",
  max_jump_height: "أقصى ارتفاع للقفز",
  lanes_settings: "إعدادات المسارات",
  number_of_lanes: "عدد المسارات",
  starting_lane: "المسار الابتدائي",
  enemies_spawn: "ظهور الأعداء",
  traps_spawn: "ظهور الفخاخ",
  min_spawn_interval_ms: "أدنى فاصل زمني للظهور (ملي ثانية)",
  max_spawn_interval_ms: "أقصى فاصل زمني للظهور (ملي ثانية)",
  same_lane_chance: "احتمال الظهور في نفس المسار",
  probability_of_spawn_in_player_lane: "احتمال الظهور في مسار اللاعب",
  collision_tolerance_px: "تسامح التصادم (بكسل)",
  scoring_rules: "قواعد التسجيل",
  hit_penalty: "عقوبة الاصطدام",
  powerup_reward: "مكافأة عنصر التعزيز",
  score_speed_divider: "مقسوم سرعة النقاط",
  reset_combo_on_hit: "إعادة تعيين الكومبو عند الاصطدام",
  camera_settings: "إعدادات الكاميرا",
  normal_zoom: "التكبير العادي",
  hit_zoom: "التكبير عند الاصطدام",
  zoom_lerp_speed: "سرعة انتقال التكبير",
  game_end_conditions: "شروط نهاية اللعبة",
  phone_dialog_score_threshold: "حد النقاط لمربع حوار الهاتف",

  // 8. تب الألوان (TabColors)
  background_gradient: "تدرج الخلفية",
  first_color: "اللون الأول",
  second_color: "اللون الثاني",
  particle_hit_color: "لون جسيمات الاصطدام",
  particle_powerup_color: "لون جسيمات عنصر التعزيز",
  main_background_color: "لون الخلفية الرئيسي",
  ground_color: "لون الأرضية",
  hud_colors: "ألوان عناصر العرض العلوي",
  hud_background: "خلفية عناصر العرض العلوي",
  score_text_color: "لون نص النقاط",
  level_text_color: "لون نص المستوى",
  combo_text_color: "لون نص الكومبو",
  overlay_colors: "ألوان الطبقة العلوية",
  backdrop_color: "لون الخلفية الخلفية",
  card_background: "خلفية البطاقة",
  card_border_color: "لون حدود البطاقة",
  explosion_particle_color: "لون جسيمات الانفجار",

  // 9. مكون عرض مسبق لـ QR (previewerQr)
  gif_tab: "تب الـGIF",
  game_tab: "تب اللعبة",
  welcome_gif_upload: "رفع GIF الترحيب",
  default_welcome: "ترحيب افتراضي",
  loading_animation: "رسوم متحركة التحميل",
  hide_previewer: "إخفاء العرض المسبق",
  show_previewer: "إظهار العرض المسبق",
  edit_game_settings: "تعديل إعدادات اللعبة",
  save_and_close: "حفظ وإغلاق",
  animation_scale: "مقياس الرسوم المتحركة",
  animation_slide_x: "رسوم متحركة انزلاق أفقي",
  animation_slide_y: "رسوم متحركة انزلاق رأسي",
  animation_fade: "رسوم متحركة تلاشي",
  game_settings_saved: "تم حفظ إعدادات اللعبة",
  no_game_configured: "لم يتم تهيئة أي لعبة",

  // 10. منتقي الـGIF (gifSelector)
  gallery_name: "اسم المعرض",
  change_gallery_name: "تغيير اسم المعرض",
  add_gif: "إضافة GIF",
  select_gif: "اختيار GIF",
  show_gif: "عرض GIF",
  selected_gif: "GIF المحدد",
  count: "العدد",
  select_category: "اختيار الفئة",
  after_typing_enter: "بعد الكتابة اضغط إنتر",
  search: "بحث",
  no_gif_available: "لا يوجد GIF متاح",
  to_use_ready_gifs_search_category_or_product:
    "لاستخدام GIF جاهز، ابحث حسب الفئة أو المنتج",
  max_file_size_2mb: "الحد الأقصى لحجم الملف 2 ميغابايت",
  upload_file: "رفع ملف",
  drag_and_drop_to_upload_or: "اسحب وأفلت للرفع أو",
  here: "هنا",
  click: "انقر",
  all: "الكل",
  no_gif_found: "لم يتم العثور على GIF",
  for_adding_file_use_upload_center: "لإضافة ملف، استخدم مركز الرفع",
  to_use_external_gif_link_fill_fields: "لاستخدام رابط GIF خارجي، املأ الحقول",
  gif_url_hint: "رابط الملف الكامل لـGIF",
  gif_url: "رابط GIF",
  add: "إضافة",
  title: "العنوان",
  link: "الرابط",
  description: "الوصف",
  add_new_gallery: "إضافة معرض جديد",
  enter_valid_link: "أدخل رابطًا صحيحًا",
  create_gif: "إنشاء GIF",
  ready_gifs: "GIF جاهزة",
  gif_gallery: "معرض GIF",
  edit_gif: "تعديل GIF",
  max_background_gif_size_2mb: "الحد الأقصى لحجم GIF الخلفية 2 ميغابايت",
  uploaded_successfully: "تم الرفع بنجاح",
  gif_upload_error: "خطأ في رفع GIF",

  // 11. نصوص إضافية ومفاتيح اختبار
  preview: "عرض مسبق",
  start_button_text: "نص زر البدء",
  game_over_text: "نص نهاية اللعبة",
  game_over_subtext: "نص فرعي نهاية اللعبة",
  mobile_prompt_text: "نص طلب الهاتف المحمول",
  submit_button_text: "نص زر الإرسال",
  optional: "اختياري",
  game_background: "خلفية اللعبة",
  background_gradient_colors: "ألوان تدرج الخلفية",
  frames_per_enemy: "إطارات لكل عدو",
  frames_per_powerup: "إطارات لكل عنصر تعزيز",
  win_threshold: "حد الفوز",
  score_to_win: "النقاط اللازمة للفوز",
  your_work_page_name: "كيوار شخصي/شركتي",
  "pdf_gallery": {
    "display_mode": "وضع عرض معرض PDF",
    "display_mode_label": "وضع العرض",
    "layout": {
      "list": "عرض كقائمة",
      "accordion": "عرض أكورديون (قابل للطي)",
      "slider": "عرض كمزلق (سلايدر)"
    },
    "gallery_name": "اسم المعرض",
    "selected_gallery": "المعرض المحدد",
    "add_file": "إضافة ملف",
    "pdf_gallery_label": "معرض PDF",
    "select_file": "اختيار ملف",
    "title": "العنوان",
    "pdf_url": "رابط PDF",
    "description": "الوصف",
    "add_button": "إضافة",
    "all": "الكل",
    "image_gallery": "معرض الصور",
    "edit_pdf": "تعديل PDF",
    "preview": "معاينة",
    "add_pdf_gallery": "إضافة معرض PDF",
    "default_gallery_name": "معرض",
    "gallery_prefix": "معرض",
    "tabs": {
      "add_file": "إضافة ملف",
      "pdf_gallery": "معرض PDF",
      "link": "الرابط"
    },
    "messages": {
      "file_too_large": "لا يمكن أن يتجاوز حجم الملف 10 ميجابايت.",
      "invalid_file_type": "يرجى اختيار ملفات المستندات والنصوص فقط.",
      "upload_error": "خطأ في رفع الملف",
      "only_pdf_txt_allowed": "يمكن إضافة ملفات PDF و TXT فقط.",
      "title_url_required": "يرجى إدخال العنوان ورابط الملف."
    }
  },
  "special_info_desc": {
    "textCards": "إضافة بطاقات نصية لعرض معلومات المستخدم مثل الأوصاف، السيرة الذاتية، أو نبذة مختصرة.",
    "customerClubSettings": "إعداد رسالة العضوية في نادي العملاء التي يتم إرسالها للمستخدمين بعد تسجيل أرقامهم.",
    "advanceSettings": "إدارة الإعدادات المتقدمة والذكية لتخصيص سلوك وميزات الصفحة.",
    "voiceGallery": "رفع وإدارة الملفات الصوتية لتشغيلها في الصفحة.",
    "VideoGallery": "إضافة وعرض مقاطع الفيديو للتعريف، التدريب، أو عرض المحتوى.",
    "imageUploader": "رفع الصور لعرضها في المعرض أو في أجزاء مختلفة من الصفحة.",
    "colorPallete": "اختيار الألوان المفضلة لتخصيص مظهر وتصميم الصفحة.",
    "socialMediaIcons": "إضافة روابط الشبكات الاجتماعية لوصول المستخدمين السريع.",
    "pdfSelector": "رفع وعرض ملفات PDF ليقوم المستخدمون بعرضها أو تنزيلها.",
    "FeedBack": "تلقي تعليقات وملاحظات المستخدمين حول الخدمات أو المحتوى.",
    "consultationNew": "إنشاء نموذج لتقديم الطلبات، الاستشارات، أو تواصل المستخدمين."
  },
  "voice_gallery": {
    "autoplay_warning": "يمكنك ضبط ملف صوتي واحد فقط للتشغيل التلقائي في نفس الوقت.",
    "autoplay": "تشغيل تلقائي"
  },
  "card": {
    "consultation": {
      "title": "نموذج الطلب"
    },
    "form": {
      "name": "الاسم",
      "surname": "اسم العائلة",
      "phone": "رقم الجوال",
      "email": "البريد الإلكتروني",
      "address": "العنوان",
      "national_id": "رقم الهوية",
      "location": "الموقع",
      "description": "الوصف"
    },
    "feedback": {
      "title": "ملاحظاتك",
      "description": "يرجى مساعدتنا في تحسين خدماتنا من خلال الإجابة على الأسئلة التالية:",
      "q1": "ما مدى رضاك عن خدمات كيوآر لاند؟",
      "q2": "إلى أي مدى غطت خدمات كيوآر لاند احتياجاتك؟",
      "q3": "ما مدى معقولية التكلفة المدفوعة مقابل الخدمة المستلمة؟",
      "q4": "شاركنا رأيك لتحسين خدماتنا."
    },
    "pdf": {
      "gallery_name": "معرض عروض كيوآر لاند",
      "item1_title": "عرض تعريف المنتج",
      "item1_desc": "تعريف شامل بخدمات كيوآر لاند، كيفية عمل رموز الاستجابة السريعة الذكية، الفوائد للشركات وأمثلة الاستخدام لزيادة تفاعل العملاء.",
      "item2_title": "عرض بطاقة العمل الإلكترونية",
      "item2_desc": "التعريف ببطاقة العمل الرقمية من كيوآر لاند، ميزات المشاركة السريعة لمعلومات الاتصال، روابط الشبكات الاجتماعية والإدارة الاحترافية للعلاقات مع العملاء."
    },
    "pdf_selector": {
      "title": "معرض PDF",
      "description": "الوصف"
    },
    "info": {
      "visit_name": "كيوآر لاند / بطاقة العمل الإلكترونية",
      "organization_name": "كيوآر لاند",
      "sub_organ": "أول منصة لإنشاء رموز QR الديناميكية",
      "user_name": "بطاقة العمل الإلكترونية",
      "fax": "فاكس: 02191016066",
      "location_desc": "طهران، شارع شريعتي، بعد جسر سيد خندان، زقاق خندان، رقم 6",
      "postal_code": "الرمز البريدي: 1541946815",
      "about_us": "نظراً للمشاكل الموجودة في بطاقات العمل الفعلية، قدمت منصة كيوآر لاند منتجاً يسمى 'بطاقة العمل الإلكترونية'. وباستخدام التقنيات الرقمية، تمكنت من القضاء تماماً على قيود بطاقات العمل الفعلية. وفي الوقت نفسه، من خلال استبدالها بالبدائل الذكية، امنع القطع المفرط للأشجار.",
      "full_address": "إيران، طهران، مدينة طهران، المنطقة 3، حي سيد خندان، د. علي شريعتي، خندان"
    },
    "extra": {
      "field1": "🟥 أنشئ بطاقة عمل إلكترونية مشابهة لعملك الخاص.\n🟧 جربها مجاناً لمدة 3 أيام.\n🟨 انقر هنا للتسجيل مجاناً.",
      "field2": "تتميز بطاقة عملك الإلكترونية برمز QR ديناميكي. يمكنك تعديل المعلومات في أي وقت عبر هاتفك المحمول. لن يتغير رمز QR الخاص بك أبداً بعد التعديل.",
      "field3": "💲 تكلفة الحصول على هذه البطاقة هي 900 ألف تومان."
    },
    "gallery": {
      "name": "سنقف دائماً بجانبك..."
    },
    "social": {
      "address_hint": "يرجى إدخال عنوانك",
      "address_label": "العنوان",
      "instagram_hint": "يرجى إدخال رابط إنستغرام الخاص بك",
      "instagram_label": "إنستغرام",
      "whatsapp_hint": "يرجى إدخال رابط واتساب الخاص بك",
      "whatsapp_label": "واتساب"
    },
    "video": {
      "item1_name": "لماذا بطاقة كيوآر لاند؟ ما الذي يميز كيوآر لاند؟",
      "item1_title": "لماذا بطاقة عمل كيوآر لاند",
      "item2_name": "التعريف ببطاقة العمل الإلكترونية كيوآر لاند",
      "item2_title": "أفضل بديل لبطاقات العمل الفعلية"
    },
    "club": {
      "title": "عضوية نادي العملاء",
      "description": "هذا ليس نادي عملاء عادي!\nسجل رقمك"
    },
    "audio": {
      "category_all": "الكل",
      "item1_title": "الدليل الشامل لبطاقات العمل الإلكترونية",
      "diff_seconds": "قبل ثانية واحدة"
    }
  },
  "pic": {
    "background_image": "صورة الخلفية",
    "image_display_type": "نوع عرض الصورة",
    "image_orientation": "اتجاه الصورة:",
    "horizontal": "أفقي",
    "vertical": "عمودي",
    "change_display_mode": "تغيير وضع العرض",
    "image": "صورة",
    "uploaded_image": "الصورة المرفوعة"
  },
  "send_limit_per_user": "حد الإرسال لكل مستخدم (0 = غير محدود)",
  "enable_discount_code": "تفعيل كود الخصم",
  "add_new_discount_code": "إضافة كود خصم جديد",
  "no_discount_codes_added": "لم يتم إضافة أي أكواد خصم",
"toolsManagment": "أدوات الإدارة",
"gateway": {
  "edit": "تعديل",
  "integrated_edit_all_sections": "تعديل متكامل لجميع الأقسام",
  "show_descriptions": "عرض الأوصاف",
  "search_section_placeholder": "البحث عن قسم...",
  "no_section_found": "لم يتم العثور على قسم بهذا الاسم.",
  "back_to_menu": "العودة إلى القائمة",
  "cancel": "إلغاء",
  "save": "حفظ"
},
"gridShow": "عرض الشبكة",
"tableShow": "عرض الجدول",
"editvisit": {
  special_info_single: {
    text_cards_description:
      "إضافة بطاقات نصية لعرض معلومات المستخدم مثل الوصف أو السجل أو نبذة قصيرة.",

    customer_club_settings_description:
      "إعداد رسالة الانضمام إلى نادي العملاء التي يتم إرسالها للمستخدمين بعد تسجيل رقم الهاتف.",

    advance_settings_description:
      "إدارة الإعدادات المتقدمة والذكية لتخصيص سلوك الصفحة وميزاتها.",

    voice_gallery_description:
      "رفع وإدارة الملفات الصوتية لتشغيلها على الصفحة.",

    video_gallery_description:
      "إضافة وعرض مقاطع الفيديو للتعريف أو التدريب أو عرض المحتوى.",

    image_uploader_description:
      "رفع الصور لعرضها في المعرض أو في أقسام مختلفة من الصفحة.",

    color_palette_description:
      "اختيار الألوان المفضلة لتخصيص مظهر وتصميم الصفحة.",

    social_media_icons_description:
      "إضافة روابط شبكات التواصل الاجتماعي للوصول السريع إليها.",
  },
},

"editBpage": {
  special_info_single: {
    banner_selector_description:
      "رفع أو تغيير صورة البانر الرئيسية للمجمع.",

    logo_select_description:
      "تعيين شعار النشاط التجاري أو المجمع.",

    service_description:
      "إدارة الخدمات والمرافق الرئيسية للمجمع.",

    faq_description:
      "إضافة وتعديل الأسئلة الشائعة للعملاء.",

    blog_description:
      "إضافة المقالات والأخبار المتعلقة بالمجمع.",

    floor_description:
      "إدارة الطوابق والوحدات التجارية في المجمع.",

    text_cards_description:
      "إدخال الوصف والمعلومات المتعلقة بالمستخدم.",

    social_media_icons_description:
      "إضافة روابط شبكات التواصل الاجتماعي للتواصل مع العملاء.",

    pic_selector_description:
      "إضافة صور المجمع والمتاجر.",

    video_gallery_description:
      "رفع مقاطع الفيديو التعريفية أو الإعلانية.",

    pdf_selector_description:
      "إدارة الكتالوجات والملفات الإرشادية النصية.",

    feedback_description:
      "إدارة قسم آراء وملاحظات الزوار.",

    consultation_new_description:
      "إدارة نموذج جمع معلومات العملاء أو طلباتهم.",

    service_section_description:
      "إنشاء أقسام مخصصة للخدمات.",

    counter_service_description:
      "عرض إحصائيات وإنجازات المجمع بشكل رقمي.",

    counter_description:
      "إعداد العد التنازلي للفعاليات أو الافتتاح.",

    personnel_description:
      "التعريف بالمديرين وأعضاء الفريق الرئيسيين.",

    customer_club_settings_description:
      "إدارة إعدادات الرسائل النصية والتسجيل في نادي العملاء.",

    work_sheet_description:
      "تحديد ساعات العمل وأيام نشاط المجمع.",

    pallet_commercial_description:
      "إعداد ألوان ونمط المظهر العام للصفحة.",

    default_description:
      "إضافة وإدارة قسم {title} في صفحة العمل.",
  },
},

store_special_info_single: {
  shop_login_config_description:
    "إعدادات صفحة تسجيل الدخول وتغيير شعار المتجر.",

  banner_selector_description:
    "رفع وإدارة لافتات المتجر.",

  text_cards_description:
    "المعلومات النصية والتعريفية ونبذة عن المتجر.",

  product_description:
    "إنشاء المنتجات وإدارتها وتعديلها.",

  special_category_manager_description:
    "إدارة فئات العروض الخاصة والمنتجات المخفضة.",

  social_media_icons_description:
    "إضافة روابط شبكات التواصل الاجتماعي للمتجر.",

  blog_description:
    "كتابة وإدارة منشورات المدونة.",

  service_description:
    "التعريف بالخدمات الإضافية المقدمة.",

  faq_description:
    "عرض وإدارة قائمة الأسئلة الشائعة للمستخدمين.",

  pic_selector_description:
    "رفع وإدارة معرض صور المتجر.",

  video_gallery_description:
    "رفع مقاطع الفيديو التعريفية والإعلانية.",

  pdf_selector_description:
    "توفير ملفات الإرشادات أو كتالوجات PDF.",

  feedback_description:
    "إدارة قسم آراء وملاحظات العملاء.",

  counter_description:
    "إعداد العد التنازلي للفعاليات أو العروض.",

  consultation_description:
    "إنشاء نموذج لاستقبال الطلبات أو طلب الاستشارة.",

  service_section_description:
    "إدارة الأقسام المخصصة للخدمات.",

  counter_service_description:
    "عرض الإحصائيات والأرقام وإنجازات المتجر.",

  personnel_description:
    "التعريف بأعضاء الفريق وموظفي المتجر.",

  work_sheet_description:
    "إعداد أيام وساعات عمل المتجر.",

  default_description:
    "إضافة وإدارة قسم {title} في صفحة المتجر.",
},
edit_gold_special_info_single: {
  product_info_title: "معلومات المنتج",
  product_info_description:
    "تسجيل وتعديل المعلومات الأساسية للمنتج والميزات والسعر والوصف الإضافي.",

  asset_management_title: "إدارة الأصول",
  asset_management_description:
    "إدارة الأصول وتخصيص القيمة ومعلومات المحفظة المرتبطة بالمنتج.",

  add_social_networks_title: "إضافة شبكات التواصل الاجتماعي",
  social_networks_title: "شبكات التواصل الاجتماعي",
  social_media_description:
    "إضافة روابط شبكات التواصل الاجتماعي لتسهيل تواصل العملاء مع علامتك التجارية.",

  add_video_title: "إضافة فيديو",
  video_description:
    "إضافة وعرض مقاطع الفيديو التعريفية أو التعليمية أو الإعلانية للمنتج.",

  add_image_title: "إضافة صورة",
  image_description:
    "رفع صور عالية الجودة للمنتج من زوايا مختلفة لعرضه بشكل أفضل في المعرض.",

  select_color_title: "اختيار اللون",
  color_palette_description:
    "تخصيص ألوان ومظهر صفحة عرض المنتج بما يتناسب مع هوية علامتك التجارية.",
},

edit_multicard_special_info_single: {
  add_account_description:
    "تعديل الاسم وصورة الملف الشخصي والخلفية",

  management_account_description:
    "إضافة وتعديل معلومات الحسابات المصرفية",

  management_color_description:
    "تغيير ألوان أزرار الواجهة والخلفية",
},

edit_feedback_special_single: {
  base_info_description:
    "تعديل المعلومات الأساسية وعنوان النموذج",

  image_uploader_description:
    "رفع وإدارة شعار نموذج الملاحظات",

  feedback_description:
    "إعدادات الحقول وإدارة نموذج استقبال الملاحظات",

  color_palette_description:
    "اختيار نظام الألوان وتخصيص مظهر النموذج",
},

edit_gitf_special_info_single: {
  default_description:
    "إضافة وإدارة قسم {title} في رمز QR لإطار الذكريات.",
},

edit_catalog_special_info_single: {
  text_cards_description:
    "المعلومات الأساسية والعنوان ووصف الكتالوج",

  image_uploader_description:
    "رفع وإدارة الشعار أو الصورة الرئيسية",

  pic_selector_description:
    "رفع وإدارة صفحات الكتالوج أو الكتيب",

  social_media_icons_description:
    "إضافة وإدارة روابط شبكات التواصل الاجتماعي",

  color_palette_description:
    "اختيار نظام الألوان وتخصيص المظهر",
},

edit_menu_special_info_single: {
  theme_selector_description:
    "اختيار قالب لتطبيق تصنيف مختلف",

  login_config_description:
    "إعدادات ومظهر صفحة تسجيل الدخول",

  general_settings_description:
    "الإعدادات العامة للعملة ونوع نشاطك التجاري.",

  banner_selector_description:
    "رفع واختيار صورة بانر لعرضها أعلى الصفحة وجعل مظهر القائمة أو الملف الشخصي أكثر جاذبية.",

  product_description:
    "إنشاء وإدارة المنتجات أو الخدمات مع تفاصيل مثل الصورة والسعر والوصف المخصص.",

  text_cards_description:
    "إضافة بطاقات نصية لعرض معلومات المستخدم الأساسية مثل الوصف العام أو الخبرات أو نبذة قصيرة.",

  social_media_description:
    "إضافة روابط وأيقونات شبكات التواصل الاجتماعي لتسهيل التواصل والوصول للعملاء.",

  photo_gallery_description:
    "إنشاء معرض صور لعرض صور المنتجات أو نماذج الأعمال أو بيئة النشاط التجاري.",

  video_gallery_description:
    "إضافة معرض فيديو لعرض الإعلانات الترويجية أو الفيديوهات التعليمية أو التعريفية.",

  feedback_description:
    "إنشاء قسم لعرض آراء العملاء وملاحظاتهم ومستوى رضا العملاء السابقين.",

  working_hours_description:
    "تحديد ساعات العمل وأوقات نشاط النشاط التجاري.",
},

edit_pdf_special_info_single: {
  base_info_title: "المعلومات",
  base_info_description:
    "إضافة بطاقات نصية لعرض المعلومات الأساسية للمستخدم مثل الوصف العام أو الخبرات أو نبذة قصيرة.",

  image_uploader_title: "رفع الشعار",
  image_uploader_description:
    "رفع واختيار صورة لاستخدامها كشعار أو صورة ملف شخصي لعرضها على الصفحة.",

  pdf_selector_title: "إضافة معرض PDF",
  pdf_selector_description:
    "إنشاء معرض لملفات PDF أو الملفات النصية مع إمكانية إضافة صورة غلاف ووصف مخصص لكل ملف.",

  social_media_icons_title: "إضافة شبكات التواصل الاجتماعي",
  social_media_icons_description:
    "إضافة روابط وأيقونات شبكات التواصل الاجتماعي لتسهيل التواصل والوصول.",

  color_palette_title: "اختيار اللون",
  color_palette_description:
    "اختيار لون القالب وتخصيص المظهر العام للعناصر ليتناسب بشكل أفضل مع علامتك التجارية.",
},

edi_photogallery_spcial_info_single: {
  default_description:
    "إضافة وإدارة قسم {title} في معرض الصور.",
},

edi_social_special_info_single: {
  banner_selector_title: "رفع الصورة",
  banner_selector_description:
    "اختيار ورفع صورة الخلفية أو البانر أعلى صفحة شبكات التواصل الاجتماعي الخاصة بك.",

  base_info_title: "المعلومات",
  base_info_description:
    "أدخل المعلومات الأساسية مثل العنوان الرئيسي ووصف ملفك الشخصي.",

  image_uploader_title: "رفع الشعار",
  image_uploader_description:
    "ارفع شعارك أو صورة ملفك الشخصي أو صورة علامتك التجارية لعرضها على الصفحة.",

  social_media_icons_title: "إضافة شبكات التواصل الاجتماعي",
  social_media_icons_description:
    "أضف روابط شبكات التواصل الاجتماعي مثل إنستغرام وتلغرام وواتساب ولينكدإن وغيرها لعرض أيقوناتها على الصفحة.",
},

edit_text_special_info_single: {
  base_info_title: "معلومات ونصوص QR",
  base_info_subtitle: "النص الرئيسي والحقول النصية",
  base_info_description:
    "تعديل العنوان والنص الرئيسي حولنا والحقول النصية المخصصة لـ QR",

  image_uploader_title: "الشعار وصورة الخلفية",
  image_uploader_subtitle: "إعدادات الصورة",
  image_uploader_description:
    "رفع وتغيير الشعار المخصص أو صورة خلفية البطاقة",

  color_palette_subtitle: "تخصيص المظهر",
  color_palette_description:
    "ضبط لون الرأس والخلفية وألوان النصوص لتحسين سهولة القراءة والتباين",
},

edit_video_special_info_single: {
  base_info_title: "المعلومات",
  base_info_description:
    "تعديل المعلومات الأساسية مثل العنوان وعنوان رمز QR.",

  image_uploader_title: "رفع الشعار",
  image_uploader_description:
    "رفع وإدارة صورة شعار الصفحة.",

  video_gallery_title: "معرض الفيديو",
  video_gallery_description:
    "إضافة وتعديل وإدارة مقاطع الفيديو لعرضها في المعرض.",

  social_media_icons_title: "إضافة شبكات التواصل الاجتماعي",
  social_media_icons_description:
    "إضافة روابط شبكات التواصل الاجتماعي ووسائل الاتصال.",

  color_palette_title: "اختيار اللون",
  color_palette_description:
    "تغيير الألوان واختيار نظام ألوان مناسب للصفحة.",
},

edit_product_special_info_single: {
  factory_info_description:
    "تعديل معلومات وتعريف المجموعة",

  single_product_editor_description:
    "تعديل المعلومات الأساسية وأزرار الدعوة إلى الإجراء مثل الشراء",

  customer_club_settings_description:
    "إعدادات نادي العملاء وإرسال الرسائل النصية",

  advance_settings_description:
    "إعدادات العرض والأمان المتقدمة",

  features_description:
    "إدارة ميزات المنتج ومواصفاته الفنية",

  voice_gallery_description:
    "رفع وإدارة البودكاست والملفات الصوتية",

  image_uploader_description:
    "رفع وإدارة معرض صور المنتج",

  video_gallery_description:
    "إضافة وإدارة معرض الفيديوهات المرتبطة",

  social_media_icons_description:
    "إضافة وإدارة روابط شبكات التواصل الاجتماعي",

  color_palette_description:
    "اختيار نظام الألوان وتخصيص القالب",
},

edit_product_pro_special_info_single: {
  factory_info_description:
    "أدخل المعلومات العامة والتعريف بالمجموعة الإنتاجية.",

  single_product_editor_description:
    "اضبط المعلومات الأساسية وشارة الثقة وزر شراء المنتج.",

  customer_club_settings_description:
    "إعدادات الرسائل النصية وانضمام العملاء إلى النادي.",

  features_description:
    "أضف ميزات المنتج ومواصفاته الفنية.",

  feedback_description:
    "قسم آراء وملاحظات المشترين.",

  consultation_description:
    "نموذج طلب استشارة أو تسجيل طلب.",

  advance_settings_description:
    "إعدادات متقدمة وذكية لعرض المنتج.",

  voice_gallery_description:
    "ملفات صوتية للتعريف بالمنتج أو إرشادات استخدامه.",

  image_uploader_description:
    "ارفع صور المنتج المختلفة.",

  video_gallery_description:
    "فيديوهات تعريفية أو تعليمية مرتبطة بالمنتج.",

  social_media_icons_description:
    "روابط شبكات التواصل الاجتماعي لمزيد من التواصل.",

  color_palette_description:
    "اضبط ألوان وأسلوب المظهر العام لصفحة المنتج.",
},

edit_voice_special_info_single: {
  base_info_voice_description:
    "المعلومات الأساسية ومواصفات معرض الصوت",

  image_uploader_description:
    "رفع وإدارة الشعار أو صورة الغلاف",

  voice_gallery_description:
    "رفع وإدارة الملفات الصوتية والبودكاست",

  color_palette_description:
    "اختيار نظام الألوان وتخصيص مظهر المعرض",
},

edit_voice_pro_special_info_single: {
  base_info_description:
    "تعديل عنوان ووصف المعرض",

  image_uploader_description:
    "رفع وإدارة الشعار والغلاف الرئيسي",

  voice_gallery_acc_description:
    "رفع وحذف وإدارة الملفات الصوتية",

  social_media_icons_description:
    "إضافة وإدارة روابط شبكات التواصل الاجتماعي",

  color_palette_description:
    "اختيار نظام الألوان وتخصيص مظهر المعرض",
},
edit_bpage_special_info_special: {
  advertising_sites: "مواقع الإعلانات",
stores: "المتاجر",

divar: "دیوار",
divar_hint: "أدخل رابط دیوار",

sheypoor: "شیپور",
sheypoor_hint: "أدخل رابط شیپور",

digikala: "دیجی‌کالا",
digikala_hint: "أدخل رابط دیجی‌کالا",

basalam: "باسلام",
basalam_hint: "أدخل رابط باسلام",

snappshop: "سناب شوب",
snappshop_hint: "أدخل رابط سناب شوب",

technolife: "تكنولايف",
technolife_hint: "أدخل رابط تكنولايف",

torob: "تروب",
torob_hint: "أدخل رابط تروب",

emalls: "إيمالز",
emalls_hint: "أدخل رابط إيمالز",

cafebazaar: "كافه بازار",
cafebazaar_hint: "أدخل رابط كافه بازار",

googleplay: "جوجل بلاي",
googleplay_hint: "أدخل رابط جوجل بلاي",

samsung: "سامسونج",
samsung_hint: "أدخل رابط متجر Galaxy",

apple: "آبل",
apple_hint: "أدخل رابط متجر App Store",
  add_audio_gallery: "إضافة معرض الملفات الصوتية",
  factory_information: "معلومات المنشأة",
  trust_badge: "شارة الثقة",
  buy_button: "زر الشراء",
  smart_settings: "الإعدادات الذكية",
  add_product_feature: "إضافة ميزة للمنتج",
  product_features: "ميزات المنتج",
  add_audio_file: "إضافة ملف صوتي",
  audio_gallery: "معرض الصوتيات",
  text: "النص",
  logo_background: "الشعار / الخلفية",
  select_color: "اختيار اللون",
  information: "المعلومات",
  luck_management: "إدارة الحظ",
  registration_management: "إدارة التسجيل",
  turning: "التقليب",
  slider: "منزلق",
  vertical: "عمودي",
  upload_catalog_brochure_images: "رفع صور الكتالوج / الكتيب",
  upload_banner: "رفع البانر",
  upload_header_image: "رفع صورة الرأس",
  upload_image: "رفع صورة",
  services: "الخدمات",
  faq: "الأسئلة الشائعة",
  blog: "المدونة",
  create_product: "إنشاء منتج",
  user_information: "معلومات المستخدم",
  add_social_media: "إضافة شبكات التواصل الاجتماعي",
  photo_gallery: "معرض الصور",
  video_gallery: "معرض الفيديو",
  pdf_gallery: "معرض ملفات PDF",
  feedback: "التعليقات",
  request_form: "نموذج الطلب",
  create_section: "إنشاء قسم",
  achievements: "الإنجازات",
  countdown: "العد التنازلي",
  team_members: "أعضاء الفريق",
  working_hours: "ساعات العمل",
  upload_logo: "رفع الشعار",
  create_store: "إنشاء متجر",
  customer_club_membership_sms: "رسالة عضوية نادي العملاء",
  product_information: "معلومات المنتج",
  asset_management: "إدارة الأصول",
  social_media: "شبكات التواصل الاجتماعي",
  add_video: "إضافة فيديو",
  add_image: "إضافة صورة",
  add_user_information: "إضافة معلومات المستخدم",
  manage_accounts: "إدارة الحسابات",
  manage_color: "إدارة الألوان",
  download_qr: "تنزيل رمز QR",
  add_store: "إضافة متجر",
  manage_appointments: "إدارة المواعيد",
},
edit_gift_special_info_special: {
  gift_story: "قصة الهدية",
  profile_image: "صورة الملف الشخصي",
  featured_images: "الصور المميزة",
  image_gallery: "معرض الصور",
  video_gallery: "معرض الفيديو",
  add_audio_file: "إضافة ملف صوتي",
  select_color: "اختيار اللون",
},
edit_insurance_special_info_special: {
  login_settings: "إعدادات تسجيل الدخول",
  shop_logo_images: "شعار وصور المتجر",
  login_page_information: "معلومات صفحة تسجيل الدخول",
  upload_banner_logo: "رفع البانر والشعار",
  user_information: "معلومات المستخدم",
  manage_products_insurance: "إدارة المنتجات / التأمينات",
  special_sale: "العروض الخاصة",
  add_social_media: "إضافة شبكات التواصل الاجتماعي",
  blog: "المدونة",
  services: "الخدمات",
  faq: "الأسئلة الشائعة",
  photo_gallery: "معرض الصور",
  video_gallery: "معرض الفيديو",
  pdf_gallery: "معرض ملفات PDF",
  feedback: "التعليقات",
  countdown: "العد التنازلي",
  request_form: "نموذج الطلب",
  create_section: "إنشاء قسم",
  achievements: "الإنجازات",
  team_members: "أعضاء الفريق",
  working_hours: "ساعات العمل",
  shop_login_description: "إعدادات شعار وصفحة تسجيل دخول المتجر",
  insurance_manage_description: "إضافة وتعديل قائمة المنتجات / الخدمات",
  banner_description: "إدارة صور الرأس",
},

};
